import React ,{useState , useEffect, useRef, SetStateAction, useCallback} from 'react'
import Pitch from '../../Pitch'
import SecondaryButton from '../../../ui/SecondaryButton'
import './performance.css'
import LabelText from '../../../ui/LabelText'
import LabelNumber from '../../../styled-components/LabelNumber'
import Switch from '../../../ui/CustomSwitch'
import InfoIcon from '../../../assets/icons/infoicon.svg'
import { PolarAreaChart } from '../../PlayerDetail/Attributes/RolesPlayedUtils'
import { DrawerContainer, SearchResults } from '../../../styled-components/Drawer.Styles'
import CloseIcon from "@mui/icons-material/Close";
import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import { Drawer } from '@mui/material'
import PrimaryButton from '../../../ui/PrimaryButton'
import { ChemistryPlayerPositions, IOption, TeamChemistry, TeamPasses } from '../../../types/IOption'
import { fetchAfterSwapData, fetchChemistryData, fetchChemistrySummaryData, fetchIndividualChemistry, fetchMatchTimeline, fetchOverallFormationData, fetchPlayerCardData, fetchPlayerPassingNetworks, fetchPredictiveChemistryConnection, fetchSeasonData, MatchBasicDetails } from '../../../pages/Chemistry/Utils'
import { useLoading } from '../../../contexts/LoadingContext'
import { ITeamMatchByMonths } from '../../../types/ITimeline'
import StandardDropdown from '../../../ui/StandardDropdown/StandardDropdown'
import { IseasonData } from '../../../types/IClubDetail'
import { fetchData, postData } from '../../../services/api'
import IApiResponse from '../../../types/IApiResponse'
import apiUrls from '../../../config/apiUrls'
import handleApiResponse from '../../../utils/handleApiResponse'
import { getBackgroundColor, getBorderColor, IArchetypeByCoach, ICoachBySeasonData, ISimulation, ISimulationAttributesData, ITeamFinancialSimulationData } from '../../../types/IPerformanceVersion2'
import { ModuleSpinner } from '../../../ui/LoadingSpinner/ModuleSpinner'
import { ITeamArchetypeData, processTeamArchetypeData, processTeamSwapArchetypeData } from '../../../types/IRolesPlayedUtils'
import { useClubSearch } from '../../../contexts/ClubSearchContext'
import LoadingSpinner from '../../../ui/LoadingSpinner'
import { IPlayerCardDetail } from '../../../types/IPlayerCardDetail'
import { formatNumberToKAndM } from '../../../utils/formatNumberToKandM'
import { useSquadSystemFitContext } from "../../../contexts/SquadSystemFitContext";
import PlayerLandingCard from '../../../ui/CardComponent'
import { PlayerAvatar } from '../../../styled-components/PlayerCard.Styles'
import { ISHortlistData, IShortlistPlayers } from '../../../pages/Shortlists/shortlist'
import { useAuth } from '../../../contexts/AuthContext'
import { IPlayerComparisonData, SortableKeys } from '../../../types/IPlayerComparison'
import { IPlayerSearchResponse } from '../../../types/IPlayerSearchResponse'
import { BackToTeamChemistryBtn } from '../../../pages/Chemistry/StyledChemistryElements'
import ResetIcon from "../../../assets/icons/Reset.png";
import Simulate from "../../../assets/icons/Simulate.png";
import { SpiderSwapGraph } from './SpiderSwapGraph'
import { usePitchWidgetContext } from '../../../contexts/PitchWidgetContext'
import { usePlayerSearch } from '../../../contexts/SearchPlayersContext'
import { useSwapHistory } from '../../../contexts/SwapHistoryContext'
import SimulationPlayerSearch from './SimulationPlayerSearch'
import ClubInitialSearch from '../../ClubLanding/ClubSearch/ClubInitialSearch'
import { TeamArchetypeInfoDrawer } from '../../../pages/Chemistry/UIContent'
import PositiveArrow from "../../../assets/icons/PositiveArrow.png";
import NegativeArrow from "../../../assets/icons/NegativeArrow.png";
import { teamSegmentGameModelGroup } from "../Performance/GameModel";
import { IGameModel, IGameModelSimulation } from "../../../types/IClubDetail";
import SimulationAttributes from './SimulationAttributes'
import AttributesBar from './AttributesBar'
import PlayerComparisonTableContent from '../../PlayerComparison/PlayerComparisonTableContent'
import SquareBarChart from '../ClubFinancial/SquareBarchart'
import UpArrow from "../../../assets/icons/ArrowUp.png"
import DownArrow from "../../../assets/icons/ArrowDown.png"
import SimulationPlayersTable from "./SimulationPlayersTable"
import { exportSimulationToPDF } from "../../../utils/pdfExport"
import { useNavigate } from 'react-router-dom';
import GameModelVisualization from './GameModelVisualization';
import { hasPlayersFromDifferentClubs } from '../../../utils/drawChemistrys'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomButton from '../../../ui/Button';
import Timeline, { SelectedData } from '../../Timeline';
import { IDisabledButtonsState, IMatches } from '../../../types/ITimeline';
import { MatchTimeLineWrapper, MatchTrackContainer } from '../../../pages/Chemistry/StyledChemistryElements';
import MatchTimeLine from '../../MatchTimeline';
import EventTimeLine from '../../EventTimeline';
import { ButtonKey } from '../../../pages/Chemistry';
import { CurrentView } from '../../../types/IPitchProps';
import { timelineVisRestrictions } from "../../../pages/Chemistry/static";

interface IPerformanceVersion2Props{
    teamId : number;
    teamName : string;
}

const PerformanceVersion2 : React.FC<IPerformanceVersion2Props> = ({ teamId , teamName }) => {
const navigate = useNavigate();
const { userData } = useAuth();    
const { startLoading , stopLoading , loading} = useLoading()
const {clubCompareId, setIsClubCompareId , setCompareClubLogoUrl , setCompareClubName ,teamCompareAttributesData, setTeamCompareAttributesData,compareClubLogoUrl , compareClubName }= useClubSearch();
const { simulationPlayerSearch , setSimulationPlayerSearch , simulationClubSearch , setSimulationClubSearch} = usePlayerSearch();
const {
selectedTeam,
setSelectedTeam,
positionResults,
setPositionResults,
teamChemistry,
setTeamChemistry,
selectedSeasonId,
setSelectedSeasonId,
timeLineTag,
setTimeLineTag,
seasonName,
setSeasonName,
zoomLevelId,
setZoomLevelId,
formationData,
setFormationData,
selectedFormation,
setSelectedFormation,
isSwapActive,
setIsSwapActive,
isIndividualChemistry,
setIsIndividualChemistry,
lastPositionResults,
setLastPositionResults,
lastTeamChemistry,
setLastTeamChemistry,
swappedPlayerClub,
setSwappedPlayerClub,
otherClubPlayer,
setOtherClubPlayer,
playerToSwap,
setPlayerToSwap,
swappedPositionResults,
setSwappedPositionResults,
swappedTeamChemistry,
setSwappedTeamChemistry,
thirdOfSeason,
setThirdOfSeason,
overallSFScore,
setOverallSFScore,
newOverallSFScore,
setNewOverallSFScore,
avgAge,
setAvgAge,
newAvgAge,
setNewAvgAge,
attackContribution,
setAttackContribution,
newAttackContribution,
setNewAttackContribution,
currentPlayerView,
setCurrentPlayerView,
playerToSwapWith,
setPlayerToSwapWith,
leagueValues,
setLeaguevalues,
disabledButtons,
setDisabledButtons,
ppda,
setPPDA,
newPPDA,
setNewPPDA,
synergyData,
setSynergyData,
selectedByPlayerPair, setSelectedByPlayerPair,
overallSystemFitScore , setOverAllSystemFitScore
} = useSquadSystemFitContext();
const {setInitialPositionResults , initialPositionResults} = usePitchWidgetContext();
const { addSwap, clearSwapHistory, swapHistory } = useSwapHistory();
const [pitchSettingDrawerOpen, setPitchSettingDrawerOpen] = useState<boolean>(false);
const [timeframeDrawerOpen , setTimeframeDrawerOpen] = useState<boolean>(false);
const [seasonData, setSeasonData] = useState<any[]>([]);
const [compareClubSeasonData, setCompareClubSeasonData] = useState<any[]>([]);
const [overAllswappSystemFitScore , setoverAllswappSystemFitScore] = useState<number>(0)
// const [selectedSeasonId, setSelectedSeasonId] = useState<number>(0);
// const [disabledButtons, setDisabledButtons] = useState<IDisabledButtonsState>({
//         play: true,
//         previous: true,
//         zoomOut: true,
//         zoomIn: true,
//         next: true,
//     });
const [matches, setMatches] = useState<any[]>([]);
const [teamMatchesByMonth, setTeamMatchesByMonth] = useState<ITeamMatchByMonths[]>([]);
// const [timeLineTag, setTimeLineTag] = useState<string>("");
// const [seasonName, setSeasonName] = useState<string>("");
// const [zoomLevelId, setZoomLevelId] = useState<1 | 2 | 3 | 4>(4);
const [seasonId, setSeasonId] = useState<number>(0);
const [archetypes, setArchetypes] = useState<IArchetypeByCoach[]>([]);
// const [teamCoaches, setTeamCoaches] = useState<IteamCoches[]>([]);
const [activeTeamGraph , setActiveTeamGraph] = useState<number>();
const [archetypeData, setArchetypeData] = useState<ITeamArchetypeData[]>([]);
const [isTeamRolesPlayedLoading , setIsTeamRolesPlayedLoading] = useState<boolean>(false)
const [comparisonTeamData, setComparisonTeamData] = useState<ITeamArchetypeData[]>([]);
const [confirmed , setConfirmed] = useState<boolean>(false);
const [seasonLabel, setSeasonLabel] = useState("");
const [activeformation , setActiveFormation] = useState<string>("")
const [targetedFormation , setTargetedFormation] = useState<string>("")
const [targetedArcheTypeFormation , setTargetedArcheTypeFormation] = useState<string>("")
const [targetedSeasonName , setTargetedSeasonName] = useState<string>("")
const [targetTeamId, setTargetTeamId] = useState<number>(0);
const [activeArcheTypeId, setActiveArcheTypeId] = useState<number>(0);
const [activeArcheTypeName, setActiveArcheTypeName] = useState<string>("");
const [activeFormationId , setActiveFoemationId] = useState<number>(0);
// const [teamChemistry, setTeamChemistry] = useState<TeamChemistry[]>([]);
// const [lastPositionResults, setLastPositionResults] = useState<ChemistryPlayerPositions[]>([]);
// const [lastTeamChemistry, setLastTeamChemistry] = useState<TeamChemistry[]>([]);
const [isDisplayInitialRect, setIsDisplayInitialRect] = useState<boolean>(true);
// const [positionResults, setPositionResults] = useState<ChemistryPlayerPositions[]>([]);
const [isChemistryDataNotEnough, setIsChemistryDataNotEnough] = useState<boolean>(false);
const [swapHoverPlayer, setSwapHoverPlayer] = useState<number>(0);
const [coachId , setCoachId] = useState<number>(0);
const [coachName , setCoachName] = useState<string>("");
const [isByCoach , setIsByCoach] = useState<boolean>(true);
const [isByArchetype , setIsByArchetype] = useState<boolean>(false);
const [squadPlayersData, setSquadPlayersData] = useState<IPlayerCardDetail[]>([]);
const [playerListFrom , setPlayerListFrom] = useState<string>('squad');
const getStyles = (option : string) => {
  const isActive = playerListFrom === option;
  return {
    background: isActive ? "#00A1E4" : "white",
    border: isActive
      ? "1px solid var(--Shades-UI-Blue-blue-600, #0093CF)"
      : "1px solid var(--Shades-UI-Blue-blue-600, #DADADA)",
    color: isActive ? "white" : "black",
    smallColor: isActive ? "white" : "#7C7D79",
  };
};
const [simulationData , setSimulationData]  = useState<ISimulation>();
const [sidebarPlayerShow, setSidebarPlayerShow] = useState<boolean>(false);
const [isPerformancSwitchToggled, setIsPerformanceSwitchToggled] = useState<boolean>(false);
const [swapPositionCode, setSwapPositionCode] = useState<string>("");
const [isReplacePlayer, setIsReplacePlayer] = useState<boolean>(false);
    const [alreadyPlottedPlayer, setAlreadyPlottedPlayer] = useState<{ playerID: number; xPosition: number; yPosition: number }>({
    playerID: -100,
    xPosition: 0,
    yPosition: 0,
    });
const [playerCardID, setPlayerCardID] = useState<number>(0);
const [playerCardDetails, setPlayerCardDeatils] = useState<IPlayerCardDetail | undefined>(undefined);
const [isSystemfitLoading, setIsSystemfitLoading] = useState<boolean>(false);
const playerCardRef = useRef(null);
const [playerShortLiastData , setPlayerShortListData] = useState<IShortlistPlayers[]>()
const [playerIds , setPlayerIds] = useState<number[]>([])
const [archeTypeBy , setIsArchetypeBy] = useState<string>('coach')
const [playerComparisonTableData, setPlayerComparisonTableData] = useState<IPlayerComparisonData[]>([]);
const [squadPlayerComparisonData , setSquadPlayerComparisonData] = useState<IPlayerComparisonData[]>([]);
const [playerCardOpen , setPlayerCardOpen] = useState<boolean>(false)
const [selectedPlayer ,setSelectedPlayer ] = useState<any>()
const playerDetailsRef = useRef<HTMLDivElement>(null);
const [inplayerIds , setInplayerIds] = useState<number[]>([]);
const [outPlayerIds , setOutPlayerIds] = useState<number[]>([])
const [initial11PlayerIds, setInitial11PlayerIds] = useState<number[]>([]);
const [swapDataLoading , setSwapDataLoading] = useState<boolean>(false)
const isSwapPlayerInProgressRef = useRef<boolean>(false);
const [teamsidebarOpen, setTeamSidebarOpen] = useState<boolean>(false);
const [compareClubseasonLabel, setCompareClubSeasonLabel] = useState("");
const [compareClubseasonId, setCompareClubSeasonId] = useState<number>(0);
const [confirmCompareTeam , setConfirmCompareTeam] = useState<boolean>(false);
const [section , setSection] = useState<string>("stylisticfit");
const [formationId , setFormationId] = useState<number>(0)
const [simulationAttributesData , setSimulationAttributesData] = React.useState<ISimulationAttributesData>()
const [teamAttributesData, setTeamAttributesData] = useState<any>();
const [squadPlayerIds , setSquadPlayerIds] = useState<number[]>([]);
const [sortKey, setSortKey] = useState<SortableKeys>("attackContribution");
const [isCompareBalckLine , setIscompareBlackLine] = useState<boolean>(true);
const [teamFinancialSimulationData , setTeamFinancialSimulationData] = useState<ITeamFinancialSimulationData>()
const [selectedSimulationTab, setSelectedSimulationTab] = useState<string>('systemFit');
const [gameModelData, setGameModelData] = useState<IGameModelSimulation | null>(null);
const [isGameModelLoading, setIsGameModelLoading] = useState<boolean>(false);
const [selectedGameModelAttributes, setSelectedGameModelAttributes] = useState<string[]>([
  "crosses",
  "passes_to_final_third",
  "shots",
  "defensive_duels"
]);
const [possessionPlayers, setPossessionPlayers] = useState<ChemistryPlayerPositions[]>([]);
const [possessionPasses, setPossessionPasses] = useState<TeamPasses[]>([]);
const [matchBasicDetails, setMatchBasicDetails] = useState<MatchBasicDetails | null>(null);
const [isPossessionLoading, setIsPossessionLoading] = useState<boolean>(false);

// State variables for possessions match selection and timeline (unique ones only)
const [timeLineDrawerOpen, setTimeLineDrawerOpen] = useState<boolean>(false);
const [selectedMatch, setSelectedMatch] = useState<number>(0);
const [displayedMatches, setDisplayedMatches] = useState<IMatches[]>([]);
const [groupIndex, setGroupIndex] = useState<number>(0);
const matchesPerPage = 13;
const [previousMatchId, setPreviousMatchId] = useState<number>(0);
const [direction, setDirection] = useState<string>("previous");
const [matchDate, setMatchDate] = useState<string>("");
const [isActualPositionToggled, setIsActualPositionToggled] = useState<boolean>(false);
const [currentView, setCurrentView] = useState<CurrentView>("passingNetwork");
const [currentPlayView, setCurrentPlayView] = useState<CurrentView>("minus");
const [isIndividualPassing, setIsIndividualPassing] = useState<boolean>(false);
const [pnSwapActive, setPNSwapActive] = useState<boolean>(false);


    useEffect(()=>{
      setCompareClubLogoUrl("");
      setIsClubCompareId(0);
      setCompareClubName("");
    },[])

    // Keep a list of the initial 11 player IDs derived from the initial position results
    useEffect(() => {
      if (initialPositionResults && initialPositionResults.length > 0) {
        setInitial11PlayerIds(initialPositionResults.map((p) => p.playerId));
      } else if (positionResults && positionResults.length > 0 && initial11PlayerIds.length === 0) {
        // Fallback: if initialPositionResults isn't available, use current positionResults
        setInitial11PlayerIds(positionResults.map((p) => p.playerId));
      }
    }, [initialPositionResults, positionResults]);

const fetchPlayerComparisondata = async (filteredPlayerIds: number[]) => {
    startLoading();
    const requestParameters = {
      playerId: filteredPlayerIds,
      userId: userData
    };
    const response: IApiResponse<any> = await postData(apiUrls.PlayerComparison, requestParameters);
    handleApiResponse(
      response,
      (playerComparisonData) => {
        stopLoading();
        if (response.data.length > 0) {
          setPlayerComparisonTableData(playerComparisonData);
        }
      },
      (error) => {
        stopLoading();
        console.error("Error fetching player comparison table data:", error);
      }
    );
};

 const fetchTeamAttributesSimulation = async () => {
        startLoading();
        try {
        const response: IApiResponse<ISimulationAttributesData> = await postData(`${apiUrls["TeamAttributesSimulation"]}`, {
           "userId": 0,
            "teamId": teamId,
            "seasonId": seasonId,
            "inPlayerIds": inplayerIds,
            "outPlayerIds": outPlayerIds
        });
        handleApiResponse( response,(AttributesSimulationData) => {
            // Don't stop loading if SwapPlayer is still in progress
            if (!isSwapPlayerInProgressRef.current) {
              stopLoading();
            }
            setSimulationAttributesData(AttributesSimulationData);
            },
            (error) => {
            // Don't stop loading if SwapPlayer is still in progress
            if (!isSwapPlayerInProgressRef.current) {
              stopLoading();
            }
            console.error("Error fetching TeamAttributesSimulation Data:", error);
            }
        );
        } catch (error) {
        // Don't stop loading if SwapPlayer is still in progress
        if (!isSwapPlayerInProgressRef.current) {
          stopLoading();
        }
        console.error("Unexpected error while TeamAttributesSimulation Data:", error);
        }
};

const fetchTeamAttributesData = async (teamId : number , setData : SetStateAction<any> ) => {
        startLoading();
        try {
          const response: IApiResponse<any> = await postData(`${apiUrls["GetTeamAttributes"]}`, {
            seasonId: seasonId,
            teamId: teamId,
          });
    
          handleApiResponse(
            response,
            (teamAttributesData) => {
              stopLoading();
              setData(teamAttributesData);
            },
            (error) => {
              stopLoading();
              console.error("Error fetching team Attributes Data:", error);
            }
          );
        } catch (error) {
          stopLoading();
          console.error("Unexpected error while fetching team Attributes Data:", error);
        }
};

const fetchGameModelData = useCallback(async () => {
    setIsGameModelLoading(true);
    try {
      if (swapHistory.length > 0) {
        // When there are swaps, use GetGameModelSimulation API
        const currentInPlayerIds = swapHistory.map(swap => swap.inPlayerId);
        const currentOutPlayerIds = swapHistory.map(swap => swap.outPlayerId);

        const response: IApiResponse<IGameModelSimulation> = await postData(`${apiUrls["GetGameModelSimulation"]}`, {
          seasonId: seasonId,
          plotAll: true,
          teamId: teamId,
          typeFilter: selectedGameModelAttributes,
          inPlayerId: currentInPlayerIds,
          outPlayerId: currentOutPlayerIds
        });

        handleApiResponse(
          response,
          (gameModelSimulationData) => {
            setIsGameModelLoading(false);
            setGameModelData(gameModelSimulationData);
          },
          (error) => {
            setIsGameModelLoading(false);
            console.error("Error fetching Game Model Simulation Data:", error);
          }
        );
      } else {
        // When no swaps, use GetGameModel API
        const response: IApiResponse<IGameModel[]> = await postData(`${apiUrls["GetGameModel"]}`, {
          seasonId: seasonId,
          teamId: teamId,
          typeFilter: selectedGameModelAttributes,
          userId: userData?.id || 1
        });

        handleApiResponse(
          response,
          (gameModelData) => {
            setIsGameModelLoading(false);
            // Convert single GameModel to simulation format for consistency
            const simulationData: IGameModelSimulation = {
              inPlayersDetail: [],
              outPlayersDetail: [],
              inGameModel: gameModelData,
              outGameModel: gameModelData
            };
            setGameModelData(simulationData);
          },
          (error) => {
            setIsGameModelLoading(false);
            console.error("Error fetching Game Model Data:", error);
          }
        );
      }
    } catch (error) {
      setIsGameModelLoading(false);
      console.error("Unexpected error while fetching Game Model Data:", error);
    }
}, [swapHistory, seasonId, teamId, selectedGameModelAttributes, userData?.id]);

const handleGameModelAttributesSelection = (key: string) => {
    setSelectedGameModelAttributes(prev =>
      prev.includes(key)
        ? prev.filter(item => item !== key)
        : [...prev, key]
    );
};

  useEffect(() => {
    const storedRemovePlayerIds: number[] = JSON.parse(localStorage.getItem("removedIds") || "[]");
    if (playerIds && playerIds.length > 0) {
      const filteredPlayerIds = playerIds.filter((id: number) => !storedRemovePlayerIds.includes(id));
    fetchPlayerComparisondata(storedRemovePlayerIds.length > 0 ? filteredPlayerIds : playerIds);
    } else {
      if (playerIds && playerIds.length > 0) {
        const filteredPlayerIds = playerIds?.filter((id: number) => !storedRemovePlayerIds.includes(id));
          fetchPlayerComparisondata(storedRemovePlayerIds.length > 0 ? filteredPlayerIds : playerIds);
      }
    }
  }, [playerIds]);


  useEffect(()=>{
    if(squadPlayerIds?.length! > 0){
      const fetchSquadPlayerComparisondata = async (squadPlayerIds: number[]) => {
          startLoading();
          const requestParameters = {
            playerId: squadPlayerIds,
            userId: userData
          };
          const response: IApiResponse<any> = await postData(apiUrls.PlayerComparison, requestParameters);
          handleApiResponse(
            response,
            (playerComparisonData) => {
              stopLoading();
              if (response.data.length > 0) {
                setSquadPlayerComparisonData(playerComparisonData);
              }
            },
            (error) => {
              stopLoading();
              console.error("Error fetching player comparison table data:", error);
            }
          );
      };
    fetchSquadPlayerComparisondata(squadPlayerIds)
    }
  },[squadPlayerIds])

useEffect(() => {
    if(selectedSimulationTab === 'gameModel' && teamId > 0 && seasonId > 0) {
      fetchGameModelData();
    }
}, [selectedSimulationTab, teamId, seasonId, selectedGameModelAttributes]);


useEffect(() => {
if (playerCardID > 0) {
    fetchPlayerCardData(startLoading, stopLoading, playerCardID, setPlayerCardDeatils);
} else {
    setPlayerCardDeatils(undefined);
}
}, [playerCardID]);

// const selectedPlayerId = selectedPlayer?.playerId;

useEffect(() => {
  if (selectedPlayer) {
    fetchPlayerCardData(
      startLoading,
      stopLoading,
      selectedPlayer,
      setPlayerCardDeatils
    );
  }
}, [selectedPlayer]);

const fetchSeasonData = async (teamId : number) => {
    const response: IApiResponse<IseasonData> = await fetchData(`${apiUrls["GetAllCompetitionSeasonsByTeamId"]}?TeamId=${teamId}`);
    handleApiResponse(
    response,
    (teamsData) => {
        if(teamsData && clubCompareId === 0){
        fetchChemistryData(
            teamId,
            teamsData.currentSeasonId,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            formationId!,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            false,
            [],
            setIsChemistryDataNotEnough,
            undefined,
            undefined,
            setLeaguevalues,
            setOverAllSystemFitScore,
            true,
            setInitialPositionResults
            );
          }
        const matchedSeason = teamsData.seasonData.find((season) => season.value === (teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId));      
        if(clubCompareId === 0){
          setSeasonLabel(matchedSeason?.label!);
          setSeasonData(teamsData.seasonData);
          setSeasonId(teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId);
        }
        else{
          setCompareClubSeasonData(teamsData.seasonData);
          setCompareClubSeasonId(teamsData.currentSeasonId === null ? teamsData.previousSeasonId : teamsData.currentSeasonId);
          setCompareClubSeasonLabel(matchedSeason?.label!);

        }
        // if (matchedSeason) {
        // }
        // else{
        //   setSeasonLabel("")
        //   setCompareClubSeasonLabel("")
        // }
    },
    (error) => {
        console.error("Error fetching competition season Data:", error);
    }
    );
};

const fetchCoachSelectionBySeasonData = async (teamId? : number , seasonId? : number ) => {
    startLoading();
    try {
    const response: IApiResponse<ICoachBySeasonData> = await postData(`${apiUrls["TeamArchetypeCoachSelectionBySeason"]}`, {
        teamId: teamId,
        seasonId: seasonId,
        overAll: false
    });
    handleApiResponse( response,(coachData) => {
        const sortedArchtypeData = coachData?.archetypes?.sort((a, b) => b?.usagePercentage - a?.usagePercentage);
        stopLoading();
        setArchetypes(coachData.archetypes);
        setActiveFormation(coachData.archetypes[0]?.formationName!)
        setActiveArcheTypeId(coachData?.archetypes[0]?.archetypeId!)
        setActiveArcheTypeName(coachData?.archetypes[0]?.archetypeName!)
        // setTeamCoaches(coachData.teamCoaches);
        setCoachName(coachData?.archetypes[0]?.coachName!)
        setCoachId(coachData?.archetypes[0]?.coachId)
        setFormationId(coachData?.archetypes[0]?.formationId)
        if(clubCompareId === 0){
          setActiveTeamGraph(sortedArchtypeData[0]?.archetypeId! + sortedArchtypeData[0]?.coachId! + sortedArchtypeData[0]?.competitionId! + sortedArchtypeData[0]?.ppg! + sortedArchtypeData[0]?.usagePercentage!)
        }
        setTargetedFormation(coachData?.archetypes[0]?.coachsBest?.formationName)
        setTargetedArcheTypeFormation(coachData?.archetypes[0]?.archetypesBest?.formationName)
        setTargetedSeasonName(coachData?.archetypes[0]?.coachsBest?.seasonName)
        setTargetTeamId(coachData?.archetypes[0]?.coachsBest?.teamId)
        },
        (error) => {
        stopLoading();
        console.error("Error fetching TeamArchetypeCoachSelectionBySeason Data:", error);
        }
    );
    } catch (error) {
    stopLoading();
    console.error("Unexpected error while TeamArchetypeCoachSelectionBySeason Data:", error);
    }
};

const fetchAnalyzeMultiPlayerSwapV2 = async (outTeamSeasonName : string , targetTeamId?: number , targetSeasonName?: string , targetFormation?: string, outTeamCoachId?: number, targetedCoachId?: number) => {
    setSwapDataLoading(true);
    try {
    const response: IApiResponse<ISimulation> = await postData(`${apiUrls["AnalyzeMultiPlayerSwapV2"]}`, {
       "inPlayerIds": inplayerIds,
        "outPlayerIds": outPlayerIds,
        "outTeamId": teamId,
        "outTeamSeasonName": outTeamSeasonName,
        "outTeamFormation": activeformation,
        // "targetTeamId": clubCompareId! > 0 &&  compareClubseasonId > 0  ? compareTragetTeamId : targetTeamId,
        // "targetTeamSeasonName": clubCompareId! > 0 &&  compareClubseasonId > 0  ? compareTragetTeamSeasonName : targetedSeasonName,
        // "targetTeamFormation": clubCompareId! > 0 &&  compareClubseasonId > 0  ? compareTragetTeamFormation : targetedFormation,
        "targetTeamId": targetTeamId,
        "targetTeamSeasonName": targetSeasonName,
        "targetTeamFormation": targetFormation,
        "outTeamCoachId": outTeamCoachId,
        "targetedCoachId": targetedCoachId,
        "isByCoach": false,
        "isByArchetype": false
    });
    handleApiResponse( response,(simulationData) => {
        setSwapDataLoading(false)
        setSimulationData(simulationData);
        },
        (error) => {
        setSwapDataLoading(false);
        console.error("Error fetching AnalyzeMultiPlayerSwapV2 Data:", error);
        }
    );
    } catch (error) {
    setSwapDataLoading(false);
    console.error("Unexpected error while AnalyzeMultiPlayerSwapV2 Data:", error);
    }
};

const fetchTeamFinancialSimulation = async () => {
  startLoading();
  try {
  const response: IApiResponse<ITeamFinancialSimulationData> = await postData(`${apiUrls["TeamFinancialSimulation"]}`, {
    "teamId":teamId,
    "seasonId":seasonId,
    "inPlayerIds":inplayerIds,
    "outPlayerIds":outPlayerIds
  });
  handleApiResponse( response,(teamFinancialSimulationData) => {
      // Don't stop loading if SwapPlayer is still in progress
      if (!isSwapPlayerInProgressRef.current) {
        stopLoading();
      }
      setTeamFinancialSimulationData(teamFinancialSimulationData);
      },
      (error) => {
        // Don't stop loading if SwapPlayer is still in progress
        if (!isSwapPlayerInProgressRef.current) {
          stopLoading();
        }
      console.error("Error fetching TeamFinancialSimulation Data:", error);
      }
  );
  } catch (error) {
    // Don't stop loading if SwapPlayer is still in progress
    if (!isSwapPlayerInProgressRef.current) {
      stopLoading();
    }
  console.error("Unexpected error while TeamFinancialSimulation Data:", error);
  }
};

useEffect(()=>{
  if(teamId > 0 && seasonId > 0)
  fetchTeamFinancialSimulation();
},[teamId,seasonId])


const fetchTeamSquadPlayerCardData = async () => {
      startLoading();
      const requestParameters = {
        teamId: teamId,
        OrderName: "Position",
        Ordering: "ASC",
        roles: [ {role: "string",},],
        status: [{status: "string",},],
        countries: [ {countryId: "string",},],
      };
      const response: IApiResponse<any[]> = await postData(apiUrls["GetSquadPlayerCardDetail"], requestParameters);
      handleApiResponse(
        response,
        (playerData) => {
          setSquadPlayersData(playerData);
          setSquadPlayerIds(playerData?.map(player => player.playerId))
        //   filterPlayers(roles, region, status);
          stopLoading();
        },
        (error) => {
          stopLoading();
          console.error("Error fetching Home Team Data:", error);
        }
      );
};
   
const fetchSortListData = async () => {
    startLoading();
    const response: IApiResponse<ISHortlistData> = await fetchData(`${apiUrls['ShortList']}${userData}`);
    handleApiResponse(response, (sortListData) => {
        stopLoading();
        localStorage.removeItem('removedIds');
        setPlayerShortListData(sortListData?.shortListPlayers)
        setPlayerIds(sortListData?.playerIds)
    }, (error) => {
        stopLoading();
        console.error('Error fetching shortlist data :', error);
    });
}



useEffect(() => {
  if (archetypes?.length > 0) {
    const activeArchetype = archetypes.find((a) => {
      const key =
        a?.archetypeId +
        a?.coachId +
        a?.competitionId +
        a?.ppg +
        a?.usagePercentage;
      return key === activeTeamGraph;
    });

    if (!activeArchetype) return;

    const target =
      archeTypeBy === 'archetype'
        ? activeArchetype?.archetypesBest
        : activeArchetype?.coachsBest;

    if(archeTypeBy === 'coach' || archeTypeBy === 'archetype'){
      fetchAnalyzeMultiPlayerSwapV2(
        activeArchetype?.seasonName,
        target?.teamId,
        target?.seasonName,
        target?.formationName,
        activeArchetype?.coachId,
        archeTypeBy === 'coach' ? activeArchetype?.coachId : target?.coachId
      );
    }
    else{
      fetchAnalyzeMultiPlayerSwapV2(
        activeArchetype?.seasonName,
        clubCompareId,
        compareClubseasonLabel,
        "",
        activeArchetype?.coachId,
        0
      );
    }
    
  }
}, [archetypes, archeTypeBy, inplayerIds, outPlayerIds, activeTeamGraph, seasonLabel ,clubCompareId]);

// correct below 
// useEffect(()=>{
//   if(archetypes?.length! > 0){
//   const activeArchetype = archetypes.find((a) => {
//     const key =
//       a?.archetypeId +
//       a?.coachId +
//       a?.competitionId +
//       a?.ppg +
//       a?.usagePercentage;
//     return key === activeTeamGraph;
//   });
//   if(inplayerIds?.length! === 0  && outPlayerIds?.length! === 0){
    
//     if (archeTypeBy === 'archetype') {
//       fetchAnalyzeMultiPlayerSwapV2(seasonLabel,activeArchetype?.archetypesBest?.teamId! , activeArchetype?.archetypesBest?.seasonName! , activeArchetype?.archetypesBest?.formationName!);
//     }
//     if(archeTypeBy === 'coach'){
//       fetchAnalyzeMultiPlayerSwapV2(seasonLabel,activeArchetype?.coachsBest?.teamId! , activeArchetype?.coachsBest?.seasonName! , activeArchetype?.coachsBest?.formationName!);
//     }
//   }
//   else{
//     if (archeTypeBy === 'archetype') {
//       fetchAnalyzeMultiPlayerSwapV2(seasonLabel,activeArchetype?.archetypesBest?.teamId! , activeArchetype?.archetypesBest?.seasonName! , activeArchetype?.archetypesBest?.formationName!);
//     }
//     if(archeTypeBy === 'coach'){
//       fetchAnalyzeMultiPlayerSwapV2(seasonLabel,activeArchetype?.coachsBest?.teamId! , activeArchetype?.coachsBest?.seasonName! , activeArchetype?.coachsBest?.formationName!);
//     }
//     if(archeTypeBy === 'team' && clubCompareId! > 0){
//       fetchAnalyzeMultiPlayerSwapV2(
//         seasonLabel,
//         clubCompareId,
//         compareClubseasonLabel,
//         ""
//       );
//     }
//   }
// }
// },[archetypes,archeTypeBy,inplayerIds,outPlayerIds])

useEffect(() => {
  setSection("stylisticfit")
  // setActiveFormation("")
  setPlayerListFrom('squad')
  setIsArchetypeBy("coach")
  // setIsClubCompareId(0)
  // setCompareClubLogoUrl("")
  // setCompareClubName("")
  // setCompareClubSeasonId(0)
  // setCompareClubSeasonLabel("")
  setInplayerIds([])
  setOutPlayerIds([])
  setIsSwapActive(false)
    if(teamId > 0 && seasonId > 0 && clubCompareId === 0){
        fetchCoachSelectionBySeasonData(teamId , seasonId);
        fetchTeamAttributesData(teamId,setTeamAttributesData)
    }
}, [teamId,seasonId]);

useEffect(() => {
  if (inplayerIds?.length > 0 && outPlayerIds?.length > 0) {
    fetchTeamAttributesSimulation();
    fetchTeamFinancialSimulation()
  }
  
}, [inplayerIds,outPlayerIds]);


useEffect(()=>{
    fetchSeasonData(teamId);
    fetchMatchTimeline(
       startLoading,
        stopLoading,
        teamId,
        setMatches,
        setDisabledButtons,
        setSelectedSeasonId,
        selectedSeasonId,
        false,
        false,
        3,
        setTeamMatchesByMonth,
        setTimeLineTag,
        setSeasonName,
        true
    );
    const fetchData = async () => {
        if (teamId !== selectedTeam) {
          try {
            await fetchOverallFormationData(teamId, setFormationData, setSelectedFormation);
          //   if(seasonId > 0){
          //   await fetchChemistryData(
          //     teamId,
          //     seasonId,
          //     setPositionResults,
          //     setTeamChemistry,
          //     startLoading,
          //     stopLoading,
          //     0,
          //     setLastTeamChemistry,
          //     setLastPositionResults,
          //     setIsDisplayInitialRect,
          //     true,
          //     [],
          //     setIsChemistryDataNotEnough,
          //     setFormationData,
          //     setSelectedFormation,
          //     setLeaguevalues,
          //     setOverAllSystemFitScore
          //   );
          // }
          //   await fetchChemistrySummaryData(true, teamId, 0, [], setLeaguevalues, startLoading, stopLoading);
            setMatches([]);
            setZoomLevelId(4);
            setIsSwapActive(false);
            setCurrentPlayerView(0);
            setSelectedTeam(teamId);
          } catch (error) { 
            if (teamId > 0) {
              setPositionResults([]);
              setTeamChemistry([]);
              setFormationData([]);
              setSelectedFormation(0);
            }
            console.error("Error fetching data:", error);
          }
        }
    };
    fetchData();
},[teamId])

useEffect(()=>{
    if(playerListFrom === 'squad' && teamId > 0){
        fetchTeamSquadPlayerCardData();
    }
    if(playerListFrom === 'shortlist' && teamId > 0){
        fetchSortListData();
    }
},[teamId , playerListFrom])

useEffect(() => {
  if (teamId > 0) {
    fetchSortListData();
  }
}, []) //eslint-disable-line react-hooks/exhaustive-deps

// Fetch possession data when possessions tab is selected
useEffect(() => {
  if (selectedSimulationTab === 'possessions' && teamId > 0) {
    setIsPossessionLoading(true);
    fetchPlayerPassingNetworks(
      teamId,
      selectedMatch,
      0,
      () => {},
      () => setIsPossessionLoading(false),
      isActualPositionToggled,
      setPossessionPlayers,
      setPossessionPasses,
      () => [], // setLastPassNetworkPlayers
      () => [],  // setLastPassNetworkPlayerPasses
      setMatchBasicDetails
    );
  }
}, [selectedSimulationTab, teamId, selectedMatch, isActualPositionToggled]) //eslint-disable-line react-hooks/exhaustive-deps

const handleConfirm = () =>{
    setPitchSettingDrawerOpen(false)
    fetchChemistryData(
         teamId,
            seasonId,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            formationId!,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            false,
            [],
            setIsChemistryDataNotEnough,
            undefined,
            undefined,
            setLeaguevalues,
            setOverAllSystemFitScore,
            true,
            setInitialPositionResults
    );
}

const handleCompareTeam = () =>{
  setIsArchetypeBy('team')
  setConfirmCompareTeam(true)
  setSimulationClubSearch(false);
  if(clubCompareId! > 0 &&  compareClubseasonId > 0){
    fetchAnalyzeMultiPlayerSwapV2(
      seasonLabel,
      clubCompareId,
      compareClubseasonLabel,
      "",
      coachId,
      0
    );
  }
  // if(clubCompareId! > 0 &&  compareClubseasonId > 0){
  //       fetchCoachSelectionBySeasonData(clubCompareId,compareClubseasonId);
  //   }
}

useEffect(()=>{
  if(clubCompareId > 0){
    fetchSeasonData(clubCompareId);
  }
},[clubCompareId])

const handleSeasonChange = (seasonId: string) => {
    setSeasonId(Number(seasonId));
    const matchedSeason = seasonData.find((season) => season.value === seasonId);
    if (matchedSeason) {
      setSeasonLabel(matchedSeason.label);
    }
    else{
      setSeasonLabel("")
    }
};

const handleCompareClubSeasonChange = (seasonId : string) =>{
    setCompareClubSeasonId(Number(seasonId));
    const matchedSeason = compareClubSeasonData.find((season) => season.value === seasonId);
    if (matchedSeason) {
      setCompareClubSeasonLabel(matchedSeason.label);
    }
    else{
      setCompareClubSeasonLabel("")
    }
}

  const handleIndividualChemistry = (playerID: number, positionCode: string) => {
    setAlreadyPlottedPlayer({
      playerID: -100,
      xPosition: 0,
      yPosition: 0,
    });
    setIsIndividualChemistry(true);
    setIsSwapActive(false);
    setLastTeamChemistry(teamChemistry);
    setLastPositionResults(positionResults);
    fetchIndividualChemistry(
      startLoading,
      stopLoading,
      playerID,
      positionCode,
      setPositionResults,
      setTeamChemistry,
      positionResults,
      selectedFormation,
      false,
      teamId,
      selectedSeasonId,
      matches.map((match) => match.matchId)
    );
  };

    const handleReset = async () => {
      // Clear swap history when resetting the team
      clearSwapHistory();

      setInplayerIds([])
      setOutPlayerIds([])
      setIsIndividualChemistry(false);
      setAlreadyPlottedPlayer({
        playerID: -100,
        xPosition: 0,
        yPosition: 0,
      });
      setSwappedPositionResults([]);
      setSwappedTeamChemistry([]);
      setSelectedByPlayerPair("Skill")
      if (lastTeamChemistry.length > 0 && lastPositionResults.length > 0) {
        setPositionResults(lastPositionResults);
        setTeamChemistry(lastTeamChemistry);
        setLastTeamChemistry([]);
        setLastPositionResults([]);
      } else {
        try {
          setIsSwapActive(false);
          setPlayerToSwapWith(0);
          setCurrentPlayerView(0);
          const matchIds = matches.map((match) => match.matchId);
          if (zoomLevelId === 4) {
            await fetchOverallFormationData(teamId, setFormationData, setSelectedFormation);
          }
          await fetchChemistryData(
            teamId,
            seasonId,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            formationId!,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            false,
            matchIds,
            setIsChemistryDataNotEnough,
            undefined,
            undefined,
            setLeaguevalues,
            setOverAllSystemFitScore,
            true
          );
          await fetchChemistrySummaryData(
            zoomLevelId === 4 ? true : false,
            teamId,
            seasonId,
            matchIds,
            setLeaguevalues,
            startLoading,
            stopLoading
          );
        } catch (error) {
          console.error("Error in handleReset:", error);
        }
      }
    };
 const getChemistrybetweenPlayers = async (player1: number, player2: number) => {
    await fetchPredictiveChemistryConnection(player1, player2, startLoading, stopLoading, setTeamChemistry, teamChemistry);
  };

  const handleAddToShortlist = async (player: IPlayerSearchResponse) => {
    // Check if player is already in the shortlist
    const existingPlayer = playerComparisonTableData.find(p => p.playerId === player.playerId);
    if (existingPlayer) {
      return; // Player already in shortlist
    }

    try {
      startLoading();

      // Use the existing API to add player to shortlist
      const requestParameters = {
        id: userData,
        shortListName: "mySortList",
        playerIds: [player.playerId],
        isRemove: false,
      };

      const response: IApiResponse<any> = await postData(apiUrls.AddOrUpdate, requestParameters);

      handleApiResponse(response, (result) => {
        stopLoading();
        if (result) {
          // Refresh the shortlist data to get the complete player information
          fetchSortListData();
        }
      }, (error) => {
        stopLoading();
        console.error('Error adding player to shortlist:', error);
      });

    } catch (error) {
      stopLoading();
      console.error('Error in handleAddToShortlist:', error);
    }
  };

  const handleSwapPlayer = async (
      playerToSwapWith: number,
      playerToGoOut?: number,
      swapPosition?: string,
      secondSwapPlayer?: ChemistryPlayerPositions
    ) => {
        // Build new in/out arrays deterministically from current values so we don't rely on stale state
        const currentIn = inplayerIds || [];
        const currentOut = outPlayerIds || [];

        // If the incoming player is an initial XI player and the outgoing player is currently in the `inplayerIds`,
        // we are swapping back to the initial XI. In that case remove the external player from `inplayerIds`
        // and remove the initial player from `outPlayerIds` (don't add the initial into `inplayerIds`).
        if (
          initial11PlayerIds.includes(playerToSwapWith) &&
          playerToGoOut !== undefined &&
          currentIn.includes(playerToGoOut)
        ) {
          const newIn = currentIn.filter((id) => id !== playerToGoOut);
          const newOut = currentOut.filter((id) => id !== playerToSwapWith && id !== playerToGoOut);
          setInplayerIds(newIn);
          setOutPlayerIds(newOut);
        } else {
          // Toggle in-player
          const willRemoveIn = currentIn.includes(playerToSwapWith);
          let newIn = willRemoveIn ? currentIn.filter((id) => id !== playerToSwapWith) : [...currentIn, playerToSwapWith];

          // Toggle out-player
          const willRemoveOut = playerToGoOut !== undefined && currentOut.includes(playerToGoOut);
          let newOut = willRemoveOut ? currentOut.filter((id) => id !== playerToGoOut) : (playerToGoOut !== undefined ? [...currentOut, playerToGoOut] : [...currentOut]);

          // Ensure mutual exclusivity: a player cannot be both in and out
          newIn = newIn.filter((id) => id !== playerToGoOut);
          newOut = newOut.filter((id) => id !== playerToSwapWith);

          // Special case: if this player is part of the initial 11 and we're toggling them back (removing from in),
          // ensure they're removed from both arrays (so they don't appear in both in/out)
          if (initial11PlayerIds.includes(playerToSwapWith) && willRemoveIn) {
            newIn = newIn.filter((id) => id !== playerToSwapWith);
            newOut = newOut.filter((id) => id !== playerToSwapWith && id !== playerToGoOut);
          }

          setInplayerIds(newIn);
          setOutPlayerIds(newOut);
        }
      if (!secondSwapPlayer) {
        const playerAlready = positionResults.filter((player) => player.playerId === playerToSwapWith);
        if (playerAlready?.length === 1) {
          setAlreadyPlottedPlayer({
            playerID: playerAlready[0].playerId,
            xPosition: playerAlready[0].xCoordinate,
            yPosition: playerAlready[0].yCoordinate,
          });
        } else {
          setAlreadyPlottedPlayer({
            playerID: -100,
            xPosition: 0,
            yPosition: 0,
          });
        }
      }
      if (selectedFormation > 0) {
        setIsSwapActive(true);
        setPlayerToSwapWith(playerToSwapWith);
        setCurrentPlayerView(playerToSwapWith);
        setIsIndividualChemistry(false);

        // Mark SwapPlayer as in progress to prevent other APIs from stopping loading
        isSwapPlayerInProgressRef.current = true;

        try {
          const positionResultsFromResponse = await fetchAfterSwapData(
            startLoading,
            stopLoading,
            playerToGoOut ? playerToGoOut : playerToSwap,
            playerToSwapWith,
            swapPosition ? swapPosition : swapPositionCode,
            formationId!,
            positionResults,
            teamChemistry,
            setPositionResults,
            setTeamChemistry,
            setSwappedPositionResults,
            setSwappedTeamChemistry,
            teamId,
            false,
            // zoomLevelId === 4 ? true : false,
            seasonId,
            matches.map((match) => match.matchId),
            setoverAllswappSystemFitScore
          );

          if (playerToGoOut && playerToGoOut && playerToGoOut !== playerToSwapWith && positionResultsFromResponse && Array.isArray(positionResultsFromResponse)) {
            const inPlayer = positionResultsFromResponse.find(p => p.playerId === playerToSwapWith);
            const outPlayer = positionResults.find(p => p.playerId === playerToGoOut);
            const isBothFromCurrTeam = inPlayer?.teamId === teamId && outPlayer?.teamId === teamId;          
            !isBothFromCurrTeam && addSwap(playerToGoOut, playerToSwapWith);
          }

          if (positionResultsFromResponse?.length! > 1 && secondSwapPlayer) {
            const newPositionResults = await fetchAfterSwapData(
              startLoading,
              stopLoading,
              0,
              playerToGoOut ? playerToGoOut : playerToSwap,
              secondSwapPlayer?.positionCode!,
              formationId!,
              positionResultsFromResponse!,
              teamChemistry,
              setPositionResults,
              setTeamChemistry,
              setSwappedPositionResults,
              setSwappedTeamChemistry,
              teamId,
              false,
              // zoomLevelId === 4 ? true : false,
              seasonId,
              matches.map((match) => match.matchId),
              setoverAllswappSystemFitScore
            );
            // setPositionResults(newPositionResults!.filter((player) => player?.playerId !== 0));
            setPositionResults(newPositionResults!);
            // setTeamChemistry(teamChemistry?.filter((connection) => connection?.score !== null));
          }
        } finally {
          // Mark SwapPlayer as complete - other APIs can now stop loading if needed
          isSwapPlayerInProgressRef.current = false;
        }
      }
      setSidebarPlayerShow(false);
  };

    const getAllMissingChemistrys = async () => {
        const allMissingLinks = teamChemistry?.filter((connection) => connection.score === 0);
        startLoading();
        const promises = allMissingLinks.map(async (connection) => {
          return fetchPredictiveChemistryConnection(
            connection.player1,
            connection.player2,
            () => {},
            () => {},
            setTeamChemistry,
            teamChemistry
          );
        });
        await Promise.all(promises);
        if (isSwapActive) {
          const allMissingLinks = swappedTeamChemistry?.filter((connection) => connection.score === 0);
          startLoading();
          const promises = allMissingLinks.map(async (connection) => {
            return fetchPredictiveChemistryConnection(
              connection.player1,
              connection.player2,
              () => {},
              () => {},
              setSwappedTeamChemistry,
              swappedTeamChemistry
            );
          });
          await Promise.all(promises);
          stopLoading();
        } else {
          stopLoading();
        }
    };
  
useEffect(() => {
    if (playerCardID && playerDetailsRef.current) {
      playerDetailsRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [playerCardID]);

   const getStylisticFit = (): number | "" => {
      // const useSimulation = (inplayerIds.length > 0 && outPlayerIds.length > 0);
      // if (useSimulation) {
      //   return Number(((simulationData?.similarity?.after ?? 0) * 100).toFixed(2));
      // }
      if (archetypes.length > 0) {
        const currentArchetype = archetypes?.find(
          (a) =>
            a?.archetypeId +
              a?.coachId +
              a?.competitionId +
              a?.ppg +
              a?.usagePercentage === activeTeamGraph
        );
        if(Number(((currentArchetype?.archetypesBest?.stylisticFit ?? 0) * 100).toFixed(2)) === 100){
          return 99.99
        }
        else{
          return Number(((currentArchetype?.archetypesBest?.stylisticFit ?? 0) * 100).toFixed(2));
        }
      }
      return "";
    };

    const getStylisticFitForCoach = (): number | "" => {
      // const useSimulation = (inplayerIds.length > 0 && outPlayerIds.length > 0);
      // if (useSimulation) {
      //   return Number(((simulationData?.similarity?.after ?? 0) * 100).toFixed(2));
      // }
      if (archetypes.length > 0) {
        const currentArchetype = archetypes?.find(
          (a) =>
            a?.archetypeId +
              a?.coachId +
              a?.competitionId +
              a?.ppg +
              a?.usagePercentage === activeTeamGraph
      );
      if(Number(((currentArchetype?.coachsBest?.stylisticFit ?? 0) * 100).toFixed(2)) === 100.00){
          return 99.99
        }
        else{
          return Number(((currentArchetype?.coachsBest?.stylisticFit ?? 0) * 100).toFixed(2));
        }
      }
      return "";
    };

    const getImprovement = () => {
      const useSimulation = (inplayerIds.length > 0 && outPlayerIds.length > 0);
      if (useSimulation) {
        return Number(((simulationData?.similarity?.improvement ?? 0) * 100).toFixed(2));
      }
    };

    const getAfterScore = () =>{
       const useSimulation = (inplayerIds.length > 0 && outPlayerIds.length > 0);
      if (useSimulation && Number(((simulationData?.similarity?.after ?? 0) * 100).toFixed(2)) != 100.00) {
        return Number(((simulationData?.similarity?.after ?? 0) * 100).toFixed(2));
      }
      if(useSimulation && Number(((simulationData?.similarity?.after ?? 0) * 100).toFixed(2)) == 100.00){
        return 99.99
      }
    }
    const getCompareStylisticFit= (): number | "" => {
      if(clubCompareId! > 0 && compareClubseasonId > 0){
        return Number(((simulationData?.similarity?.after ?? 0) * 100).toFixed(2));
      }
      return "";
    }


  const getSeasonName= (): string | "" => {
    // const useSimulation = inplayerIds.length > 0 && outPlayerIds.length > 0;
    //   if (useSimulation) {
    //     return simulationData?.similarity?.improvement?.toFixed(2);
    //   }
     if(archetypes.length > 0){
      const currentArchetype = archetypes?.find(a =>
        a?.archetypeId + a?.coachId + a?.competitionId + a?.ppg + a?.usagePercentage === activeTeamGraph
      );
        return currentArchetype?.archetypesBest?.seasonName ?? "";
    }
    else{
      return ""
    }
  }

    const getSeasonNameForCoach = (): string | "" => {
    // const useSimulation = inplayerIds.length > 0 && outPlayerIds.length > 0;
    //   if (useSimulation) {
    //     return simulationData?.similarity?.improvement?.toFixed(2);
    //   }
     if(archetypes.length > 0){
      const currentArchetype = archetypes?.find(a =>
        a?.archetypeId + a?.coachId + a?.competitionId + a?.ppg + a?.usagePercentage === activeTeamGraph
      );
        return currentArchetype?.coachsBest?.seasonName ?? "";
    }
    else{
      return ""
    }
  }

  const getClubName = (): string | "" => {
    // const useSimulation = inplayerIds.length > 0 && outPlayerIds.length > 0;
    //   if (useSimulation) {
    //     return simulationData?.similarity?.improvement?.toFixed(2);
    //   }
    if(archetypes.length > 0){
      const currentArchetype = archetypes?.find(a =>
        a?.archetypeId + a?.coachId + a?.competitionId + a?.ppg + a?.usagePercentage === activeTeamGraph
      );
        return currentArchetype?.archetypesBest?.teamName ?? "";
    }
    else{
      return ""
    }
      
  }

  const getClubNameForCoach = (): string | "" => {
    // const useSimulation = inplayerIds.length > 0 && outPlayerIds.length > 0;
    //   if (useSimulation) {
    //     return simulationData?.similarity?.improvement?.toFixed(2);
    //   }
    if(archetypes.length > 0){
      const currentArchetype = archetypes?.find(a =>
        a?.archetypeId + a?.coachId + a?.competitionId + a?.ppg + a?.usagePercentage === activeTeamGraph
      );
      return currentArchetype?.coachsBest?.teamName ?? "";
    }
    else{
      return ""
    }
      
  }

  const getPlayingStyleForCoach = (): string | "" => {
    if(archetypes.length > 0){
      const currentArchetype = archetypes?.find(a =>
        a?.archetypeId + a?.coachId + a?.competitionId + a?.ppg + a?.usagePercentage === activeTeamGraph
      );
      return currentArchetype?.archetypeName ?? "";
    }
    else{
      return ""
    }
  }

  const getDifferenceValue = (beforeValue : number , afterValue : number , ifAge?:boolean) => {
    if(ifAge){
      return (afterValue - beforeValue).toFixed(2)
    }else{
      return (afterValue - beforeValue).toFixed(2)
    }
}

  const handleExportToPDF = async () => {
    try {

      await exportSimulationToPDF({}, {
        filename: `${teamName?.replace(/\s+/g, '-') || 'team'}-simulation-${seasonLabel || 'season'}`,
        includePitch: selectedSimulationTab === 'systemFit',
        format: 'a4',
        orientation: 'landscape',
        quality: 0.95,
        scale: 2
      });

    } catch (error) {
      console.error('Error exporting PDF:', error);
    }
  };

  const handleSelectMatch = async (matchId: number) => {
    setSelectedMatch(matchId);
    setZoomLevelId(1);
  };

  const handleActualPositionSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();
    setIsActualPositionToggled((prev) => !prev);
    setIsIndividualPassing(false);
    setPNSwapActive(false);
  };

  
  const handleTimelineConfirm = async (selectedData: SelectedData) => {
    const { zoomLevelId: newZoomLevelId, seasonId: newSeasonId, selectedOption, matchId, overall } = selectedData;
    setZoomLevelId(newZoomLevelId);
    setSelectedSeasonId(newSeasonId);
    setThirdOfSeason(selectedOption!!);

    if (overall) {
      setSelectedMatch(0);
      setMatches([]);
    } else {
      if (newZoomLevelId === 1 && matchId && matchId !== -1) {
        // For single match selection, call handleSelectMatch which handles all the API calls
        await handleSelectMatch(matchId);
      }
      // Note: For other zoom levels (2, 3), additional logic can be added here if needed
    }
  };

  const handleTimelineSeasonChange = async (seasonId: number) => {

    startLoading();
    try {
      await fetchMatchTimeline(
        startLoading,
        () => {}, // Don't call stopLoading here - let the callback handle it
        teamId,
        setMatches,
        setDisabledButtons,
        setSelectedSeasonId,
        seasonId,
        false,
        false,
        3, // Use zoom level 3 to get full season data
        setTeamMatchesByMonth,
        setTimeLineTag,
        setSeasonName,
        false, // Set isDisplayMonthMatches to false
        async (updatedMatches, updatedSeasonId) => {
          stopLoading();
        }
      );
    } catch (error) {
      // Ensure stopLoading is called even if there's an error
      stopLoading();
      console.error("Error fetching timeline data:", error);
    }
  };

  // Effect for displayed matches
  useEffect(() => {
    const reversedMatches = matches.slice().reverse();
    const startIndex = groupIndex * matchesPerPage;
    const endIndex = startIndex + matchesPerPage;
    let newDisplayedMatches;
    if (matches.length < matchesPerPage) {
      newDisplayedMatches = reversedMatches.slice(startIndex, endIndex);
    } else {
      const rever = reversedMatches.reverse().slice(startIndex, endIndex);
      newDisplayedMatches = rever.reverse();
    }
    setDisplayedMatches(newDisplayedMatches);
  }, [matches, groupIndex, matchesPerPage]);

  return (
    <>
    <div style={{width:'100%', display:'flex',marginTop:'40px',gap:'20px'}}>
        <div className="performance-left-container">
            <div className="pitch-selection-container">
              {selectedSimulationTab === 'systemFit' && (
                <SecondaryButton
                  label={seasonLabel! + " > " + " " + coachName! + " >  " + activeformation! + " - " + activeArcheTypeName!}
                  onClick={()=>{setPitchSettingDrawerOpen(true)}}
                />
              )}

              {
              selectedSimulationTab === 'possessions' && (
                <>
                  <div className="pitch-formation">
                    <CustomButton
                      endIcon={<KeyboardArrowDownIcon style={{ color: 'black' }} />}
                      color="primary"
                      onClick={() => {
                        setTimeLineDrawerOpen(true);
                        fetchMatchTimeline(
                          startLoading,
                          stopLoading,
                          teamId,
                          setMatches,
                          setDisabledButtons,
                          setSelectedSeasonId,
                          selectedSeasonId,
                          false,
                          false,
                          3,
                          setTeamMatchesByMonth,
                          setTimeLineTag,
                          setSeasonName,
                          true
                        );
                      }}
                    >
                      <LabelText className="player-search-text">
                      {zoomLevelId === 4
                        ? "Overall"
                        : matchBasicDetails?.label || (() => {
                            let currentMatch = null;
                            for (const monthData of teamMatchesByMonth) {
                              const match = monthData.matchTeams?.find(m => m.matchId.toString() === selectedMatch.toString());
                              if (match) {
                                currentMatch = match;
                                break;
                              }
                            }

                            // Fallback to matches array if not found in teamMatchesByMonth
                            if (!currentMatch) {
                              currentMatch = matches?.find(m => m.matchId.toString() === selectedMatch.toString());
                            }

                            return currentMatch?.matchLabel || 'Select Match';
                          })()
                      }
                    </LabelText>
                    </CustomButton>
                  </div>
                  <div className="pitch-performance">
                    <LabelText className="player-given-name">Actual Positioning</LabelText>
                    <Switch
                      id="player-switch"
                      toggled={isActualPositionToggled}
                      onChange={handleActualPositionSwitchClick}
                      source="Filter"
                      isByComparison={false}
                    />
                  </div>
                </>

              )
            }

              {selectedSimulationTab !== 'systemFit' && selectedSimulationTab !== 'possessions' && (
                <div style={{width: '300px'}}></div>
              )}

              <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                {['systemFit', 'gameModel', 'possessions'].map((tab) => (
                  <SecondaryButton
                    key={tab}
                    label={tab === 'systemFit' ? 'System Fit' : tab === 'gameModel' ? 'Game Model' : 'Possessions'}
                    isSelected={selectedSimulationTab === tab}
                    onClick={() => setSelectedSimulationTab(tab)}
                  />
                ))}
                
              </div>
            </div>
          <div style={{width:'1020px',height:'auto',position:'relative'}}>
            {/* Chemistry buttons */}
            {selectedSimulationTab === 'systemFit' && (
              <div className="simulation_system-fit-controls">
                  {isSwapActive && (
                  <BackToTeamChemistryBtn onClick={() => handleReset()}>
                      <img src={ResetIcon} alt="reset icon" />
                      Reset team
                  </BackToTeamChemistryBtn>
                  )}
                  {(teamChemistry?.some((connection) => connection.score === 0) ||
                  (isSwapActive && swappedTeamChemistry?.some((connection) => connection.score === 0))) && (
                  <BackToTeamChemistryBtn onClick={() => getAllMissingChemistrys()}
                  style={{
                    position: 'relative',
                    top: '0px',
                    right: '0px',
                  }}>
                    <img src={Simulate} alt="simulate icon" />
                    Predict missing scores
                  </BackToTeamChemistryBtn>
                  )}
              </div>
            )}
              {selectedSimulationTab === 'gameModel' ? (
                <GameModelVisualization
                    gameModelData={gameModelData}
                    swapHistoryLength={swapHistory.length}
                    teamId={teamId}
                    setSidebarPlayerShow={setSidebarPlayerShow}
                    isPerformancSwitchToggled={isPerformancSwitchToggled}
                    setPlayerCardID={setPlayerCardID}
                />
              ) : (
                <div className="pitch-container-for-pdf">
                  <Pitch
                      currentView={selectedSimulationTab === 'possessions' ? 'passingNetwork' : 'systemFit'}
                      selectedTeam={selectedSimulationTab === 'possessions' ? teamId : teamId}
                      selectedMatch={selectedSimulationTab === 'possessions' ? selectedMatch : 0}
                      setSidebarPlayerShow={setSidebarPlayerShow}
                      isPerformancSwitchToggled={isPerformancSwitchToggled}
                      positionResults={selectedSimulationTab === 'possessions' ? possessionPlayers : (currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults)}
                      teamChemistry={selectedSimulationTab === 'possessions' ? [] : (currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? teamChemistry : swappedTeamChemistry)}
                      passNetworkPlayers={selectedSimulationTab === 'possessions' ? possessionPlayers : undefined}
                      passNetworkPlayerPasses={selectedSimulationTab === 'possessions' ? possessionPasses : undefined}
                      setSwapHoverPlayer={setSwapHoverPlayer}
                      setSwapPositionCode={setSwapPositionCode}
                      setIsReplacePlayer={setIsReplacePlayer}
                      handleIndividualChemistry={handleIndividualChemistry}
                      isIndividualChemistry={isIndividualChemistry}
                      handleReset={handleReset}
                      setIsIndividualChemistry={setIsIndividualChemistry}
                      swappedPlayerClub={swappedPlayerClub}
                      otherClubPlayer={otherClubPlayer}
                      alreadyPlottedPlayer={alreadyPlottedPlayer}
                      setPlayerCardID={setPlayerCardID}
                      isDisplayInitialRect={isDisplayInitialRect}
                      getChemistrybetweenPlayers={getChemistrybetweenPlayers}
                      formationName={formationData.find((form) => form.id === selectedFormation)?.formation}
                      isChemistryDataNotEnough={isChemistryDataNotEnough}
                      playerCardID={playerCardID}
                      handleSwapPlayer={handleSwapPlayer}
                      isSystemfitLoading={isSystemfitLoading}
                      selectedByPlayerPair={selectedByPlayerPair}
                      synergyData={selectedSimulationTab === 'possessions' ? [] : synergyData}
                      isForSimulation={true}
                  />
                </div>
              )}

                {/* Possessions Loading Spinner */}
                {selectedSimulationTab === 'possessions' && isPossessionLoading && (
                  <div style={{
                    position: 'absolute',
                    top: '260px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 100,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                    <ModuleSpinner />
                  </div>
                )}

                {/* Possession Statistics Panel */}
                {selectedSimulationTab === 'possessions' && matchBasicDetails && matchBasicDetails.homeTeam && matchBasicDetails.awayTeam && (() => {
                  const matchDate = new Date(matchBasicDetails.dateTime);

                  const getOrdinalSuffix = (day: number): string => {
                    if (day > 3 && day < 21) return "th";
                    switch (day % 10) {
                      case 1:
                        return "st";
                      case 2:
                        return "nd";
                      case 3:
                        return "rd";
                      default:
                        return "th";
                    }
                  };

                  const day = matchDate.getDate();
                  const month = matchDate.toLocaleDateString("en-GB", { month: "long" });
                  const year = matchDate.getFullYear();
                  const formattedDate = `${day}${getOrdinalSuffix(day)} ${month} ${year}`;

                  const label = matchBasicDetails?.label || "";
                  const commaIndex = label.lastIndexOf(",");
                  const teams = label.substring(0, commaIndex);
                  const score = label.substring(commaIndex + 1).trim();
                  const displayLabel = teams.length > 25 ? `${teams}\n${score}` : label;

                  return (
                    <div className="py-2" style={{ marginTop: '20px' }}>
                      <div
                        className="px-4 py-6 rounded relative overflow-hidden"
                      >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '24px', marginBottom: '16px' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img
                              src={matchBasicDetails.homeTeam.teamUrl || ''}
                              alt={matchBasicDetails.homeTeam.teamName || 'Home team'}
                              style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                            />
                          </div>

                          <LabelText className="secondary-cta-text" style={{ fontWeight: 'bold', fontSize: '18px' }}>VS</LabelText>

                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img
                              src={matchBasicDetails.awayTeam.teamUrl || ''}
                              alt={matchBasicDetails.awayTeam.teamName || 'Away team'}
                              style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                            />
                          </div>
                        </div>

                        <div style={{ textAlign: 'center' }}>
                          <div style={{
                            marginBottom: '4px'
                          }}>
                            <LabelText className="secondary-cta-text" style={{
                              fontSize: '16px',
                              lineHeight: '1.5',
                              whiteSpace: 'pre-line',
                              fontWeight: '600'
                            }}>
                              {displayLabel}
                            </LabelText>
                          </div>
                          <div>
                            <LabelNumber className='valuegraph-toggle-text' style={{ fontSize: '14px' }}>
                              {formattedDate}
                            </LabelNumber>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* GameModel Attributes Panel */}
                {selectedSimulationTab === 'gameModel' && (
                  <>
                    {isGameModelLoading && (
                      <div style={{
                        position: 'absolute',
                        top: '260px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center'
                      }}>
                        <ModuleSpinner />
                      </div>
                    )}
                    <div className='simulation_attributes-table-main' style={{width: '100%', alignSelf: 'center', marginTop: '20px'}}>
                        {teamSegmentGameModelGroup?.map((section, index) => (
                            <div className='simulation_attributes-group-container' key={index}>
                            <div className='simulation_group-title-container'>
                                <LabelText className='player-given-name'>{section.title}</LabelText>
                            </div>
                            <div className='simulation_group-attributes-container'>
                                {section.Segments.map((attr, idx) => (
                                    <>
                                        <div
                                            className='simulation_attribute-table-selection-item'
                                            key={idx}
                                            style={{
                                                backgroundColor: selectedGameModelAttributes.includes(attr.key) ? 'white' : 'transparent',
                                                borderColor: selectedGameModelAttributes.includes(attr.key) ? attr.color : 'transparent'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = attr.color;
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!selectedGameModelAttributes.includes(attr.key)) {
                                                    e.currentTarget.style.borderColor = 'transparent';
                                                }
                                            }}
                                            onClick={() => handleGameModelAttributesSelection(attr.key)}
                                        >
                                            <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                                            <input
                                                type="checkbox"
                                                id={attr.key}
                                                className="simulation_custom-checkbox"
                                                name="game_model_attribute"
                                                value={attr.key}
                                                checked={selectedGameModelAttributes.includes(attr.key)}
                                                style={{
                                                  pointerEvents: 'none',
                                                }}
                                                readOnly
                                            />
                                            <div style={{height:'9px',width:'9px',borderRadius:'2px',background:attr.color}}></div>
                                            <LabelText style={{color:attr.color}}>{attr.label}</LabelText>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                            </div>
                        ))}
                    </div>
                  </>
                )}

                 {playerCardID > 0 && playerCardDetails?.playerId! > 0 && (
                <div className="squad-pitch-player-card" ref={playerCardRef}>
                <PlayerLandingCard
                    key={playerCardDetails?.playerId!}
                    playerId={playerCardDetails?.playerId!}
                    givenName={playerCardDetails?.givenName!}
                    familyname={playerCardDetails?.familyname!}
                    playerImageURL={playerCardDetails?.playerImageURL!}
                    isInjured={playerCardDetails?.isInjured!}
                    onLoan={playerCardDetails?.onLoan!}
                    primaryPlayingPosition={playerCardDetails?.primaryPlayingPosition!}
                    age={playerCardDetails?.age!}
                    heightInCM={playerCardDetails?.heightInCM!}
                    playerAttributesByPosition={playerCardDetails?.playerAttributesByPosition!}
                    contributionValue={playerCardDetails?.contributionValue!}
                    performanceValue={playerCardDetails?.performanceValue!}
                    setPlayerCardDeatils={setPlayerCardDeatils}
                    setPlayerCardID={setPlayerCardID}
                    isPlayerInShortlist={playerCardDetails?.isPlayerInShortlist!}
                    isEasternPlayer={playerCardDetails?.isEasternPlayer!}
                    playerLabel={playerCardDetails?.playerLabel!}
                    archetypeName={playerCardDetails?.archetypeName!}
                    archetypeId={playerCardDetails?.archetypeId!}
                />
                </div>
            )}
            </div>
            
            {/* <div className='stastical-container'>
                <LabelText className="secondary-cta-text">New player statistical effect:</LabelText>
                <div className='form-buttons-container'>
                    <LabelText className="secondary-cta-text">Isak</LabelText>
                    <Switch id="starts-only" toggled={true} />
                </div>
                <div className='form-buttons-container'>
                    <LabelText className="secondary-cta-text">Kim</LabelText>
                    <Switch id="starts-only" toggled={true} />
                </div>
            </div> */}
            {/* <div className='summary-values-container'>
                <div className='squad-chemistry-box' style={{width:'258px',alignItems:'flex-start'}}>
                    <LabelNumber className='valuegraph-toggle-text'>x league position</LabelNumber>
                    <span>00</span>
                </div>
                <div className='squad-chemistry-box' style={{width:'258px',alignItems:'flex-start'}}>
                    <LabelNumber className='valuegraph-toggle-text'>x points</LabelNumber>
                    <span>--</span>form-checkbox-list
                </div>
                <div className='squad-chemistry-box' style={{width:'258px',alignItems:'flex-start'}}>
                    <LabelNumber className='valuegraph-toggle-text'>x goals</LabelNumber>
                    <span>--</span>
                </div>
                <div className='squad-chemistry-box' style={{width:'258px',alignItems:'flex-start'}}>
                    <LabelNumber className='valuegraph-toggle-text'>x assists</LabelNumber>
                    <span>00</span>
                </div>
                <div className='squad-chemistry-box' style={{width:'258px',alignItems:'flex-start'}}>
                    <LabelNumber className='valuegraph-toggle-text'>x goals against</LabelNumber>
                    <span>--</span>
                </div>
            </div> */}
            {/* SystemFit specific bottom container */}
            {selectedSimulationTab === 'systemFit' && (
            <div className='bottom-container'>
                <div className='values-container'>
                        <div className='values-box' onClick={()=>setSection("stylisticfit")} style={{backgroundColor : section === "stylisticfit" ? "white" : "transparent"}}>
                            <div className='values-box-content'>
                                <div className='content-value' style={{display:'flex',gap:'4px'}}>
                                    <LabelText className="secondary-cta-text">System fit</LabelText>
                                    <div className='pitch-selection-container' style={{padding:'0px'}}>
                                        {(() => {
                                          const systemFitDiff = overAllswappSystemFitScore - overallSystemFitScore!;
                                          return inplayerIds?.length! > 0 && outPlayerIds?.length! > 0 && systemFitDiff !== 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) && (
                                            <LabelNumber className='event-player-card-details' style={{color: systemFitDiff > 0 ? '#00D1A8' : '#FF3864' }}>
                                              <img height={16} width={16} src={systemFitDiff > 0 ? PositiveArrow : NegativeArrow} alt="negative" />
                                              {`${Math.abs(systemFitDiff)}`}
                                            </LabelNumber>
                                          )
                                        })()}
                                        <div className="values-content" style={{backgroundColor: getBackgroundColor(overAllswappSystemFitScore || overallSystemFitScore) , border : `1px solid ${getBorderColor(overallSystemFitScore)}`}}>
                                            <LabelNumber className="event-player-card-details">{overAllswappSystemFitScore || overallSystemFitScore.toFixed(2)}</LabelNumber>
                                        </div>
                                    </div>
                                </div>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Stylistic fit</LabelText>
                                    <div className='pitch-selection-container' style={{padding:'0px'}}>
                                        {inplayerIds?.length! > 0 && outPlayerIds?.length! > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) && (
                                        <LabelNumber className='event-player-card-details' style={{color: getImprovement()! > 0 ? '#00D1A8' : '#FF3864' }}>
                                            {Math.abs(getImprovement()!) !== 0 &&(<img height={16} width={16} src={getImprovement()! > 0 ? PositiveArrow : NegativeArrow} alt="negative" />)}
                                            {`${Math.abs(getImprovement()!) === 0 ? "" : Math.abs(getImprovement()!)}`}
                                        </LabelNumber>
                                        )}
                                        <div
                                              className="values-content"
                                              style={{
                                                backgroundColor: getBackgroundColor(
                                                  inplayerIds.length === 0 && outPlayerIds.length === 0
                                                    ? archeTypeBy === "coach"
                                                      ? getStylisticFitForCoach() ?? 0
                                                      : archeTypeBy === "archetype"
                                                      ? getStylisticFit() ?? 0
                                                      : archeTypeBy === "team"
                                                      ? getCompareStylisticFit() ?? 0
                                                      : getAfterScore() ?? 0
                                                    : getAfterScore() ?? 0
                                                ),
                                                border: `1px solid ${getBorderColor(
                                                  inplayerIds.length === 0 && outPlayerIds.length === 0
                                                    ? archeTypeBy === "coach"
                                                      ? getStylisticFitForCoach() ?? 0
                                                      : archeTypeBy === "archetype"
                                                      ? getStylisticFit() ?? 0
                                                      : archeTypeBy === "team"
                                                      ? getCompareStylisticFit() ?? 0
                                                      : getAfterScore() ?? 0
                                                    : getAfterScore() ?? 0
                                                )}`,
                                              }}
                                            >
                                              <LabelNumber className='event-player-card-details'>{`${(
                                              inplayerIds.length === 0 && outPlayerIds.length === 0
                                                ? (archeTypeBy === "coach"
                                                    ? getStylisticFitForCoach() ?? 0
                                                    : archeTypeBy === "archetype"
                                                    ? getStylisticFit() ?? 0
                                                    : archeTypeBy === "team"
                                                    ? getCompareStylisticFit() ?? 0
                                                    : getAfterScore())
                                                : getAfterScore()
                                            )}`}</LabelNumber>
                                        </div>
                                    </div>
                                </div>
                                {/* a?.archetypeId + a?.coachId + a?.competitionId + a?.ppg + a?.usagePercentage */}
                                 <div className='content-value'>
                                    {/* <LabelText className="secondary-cta-text">Expected points</LabelText> */}
                                    {/* <div className="values-content"></div> */}
                                </div>
                            </div>
                        </div>
                         <div className='values-box' onClick={()=>setSection("attributes")} style={{backgroundColor : section === "attributes" ? "white" : "transparent"}}>
                            <div className='values-box-content'>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Final third</LabelText>
                                    <AttributesBar
                                        height={28}
                                        width={200} 
                                        beforeValue={teamAttributesData?.finalThird?.avgScore!} 
                                        afterValue={simulationAttributesData?.teamAttributesNew?.finalThird?.avgScore!}
                                        inPlayerIds={inplayerIds}
                                        outPlayerIds={outPlayerIds} 
                                        color={getBackgroundColor(teamAttributesData?.finalThird?.avgScore!)}
                                        positionResults={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults}
                                        teamId={teamId}
                                      />
                                </div>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Build up play</LabelText>
                                    <AttributesBar
                                        height={28}
                                        width={200}
                                        beforeValue={teamAttributesData?.buildUpPlay?.avgScore!}
                                        afterValue={simulationAttributesData?.teamAttributesNew?.buildUpPlay?.avgScore!}
                                        inPlayerIds={inplayerIds}
                                        outPlayerIds={outPlayerIds}
                                        color={getBackgroundColor(teamAttributesData?.buildUpPlay?.avgScore!)}
                                        positionResults={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults}
                                        teamId={teamId}
                                    />
                                </div>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Defensive</LabelText>
                                    <AttributesBar
                                        height={28}
                                        width={200}
                                        beforeValue={teamAttributesData?.defence?.avgScore!}
                                        afterValue={simulationAttributesData?.teamAttributesNew?.defence?.avgScore!}
                                        inPlayerIds={inplayerIds}
                                        outPlayerIds={outPlayerIds}
                                        color={getBackgroundColor(teamAttributesData?.defence?.avgScore!)}
                                        positionResults={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults}
                                        teamId={teamId}
                                    />
                                </div>
                            </div>
                        </div>
                         <div className='values-box' onClick={()=>setSection("financial")} style={{backgroundColor : section === "financial" ? "white" : "transparent"}}>
                            {(() => {
                                const squadValueDiff = Number(getDifferenceValue(teamFinancialSimulationData?.beforValue?.squadValue!, teamFinancialSimulationData?.afterValue?.squadValue!));
                                const totalWagesDiff = Number(getDifferenceValue(teamFinancialSimulationData?.beforValue?.totalWages!, teamFinancialSimulationData?.afterValue?.totalWages!));
                                const avgAgeDiff = Number(getDifferenceValue(teamFinancialSimulationData?.beforValue?.avgAgeValue!, teamFinancialSimulationData?.afterValue?.avgAgeValue!, true));

                                return (
                            <div className='values-box-content'>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Squad value</LabelText>
                                    <div className='pitch-selection-container' style={{padding:'0px'}}>
                                        <div>
                                              {inplayerIds.length! > 0 && outPlayerIds?.length! > 0 && squadValueDiff !== 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) && (
                                                  <>
                                                      <img height={14} width={10} src={squadValueDiff > 0 ? UpArrow : DownArrow} alt="trend arrow" className={squadValueDiff > 0 ? "arrow-up-bad" : "arrow-down-good"}/>
                                                      <LabelNumber className='event-player-card-details' style={{color : squadValueDiff > 0 ? "#FF3864" : "#00D1A8"}}>
                                                          {formatNumberToKAndM(Math.abs(squadValueDiff))}
                                                      </LabelNumber>
                                                  </>
                                              )}
                                        </div>
                                        <div className="values-content">
                                            <LabelNumber className="event-player-card-details">
                                            €{teamFinancialSimulationData?.beforValue?.squadValueText!}
                                            </LabelNumber>
                                        </div>
                                    </div>
                                </div>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Total wages pw</LabelText>
                                    <div className='pitch-selection-container' style={{padding:'0px'}}>
                                        <div>
                                              {inplayerIds.length! > 0 && outPlayerIds?.length! > 0 && totalWagesDiff !== 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) && (
                                                  <>
                                                      <img height={14} width={10} src={totalWagesDiff > 0 ? UpArrow : DownArrow} alt="trend arrow" className={totalWagesDiff > 0 ? "arrow-up-bad" : "arrow-down-good"}/>
                                                      <LabelNumber className='event-player-card-details' style={{color : totalWagesDiff > 0 ? "#FF3864" : "#00D1A8"}}>
                                                          {formatNumberToKAndM(Math.abs(totalWagesDiff))}
                                                      </LabelNumber>
                                                  </>
                                              )}
                                        </div>
                                        <div className="values-content">
                                            <LabelNumber className="event-player-card-details">
                                            €{teamFinancialSimulationData?.beforValue?.totalWagesText!}
                                            </LabelNumber>
                                        </div>
                                    </div>
                                </div>
                                <div className='content-value'>
                                    <LabelText className="secondary-cta-text">Av. Age</LabelText>
                                    <div className='pitch-selection-container' style={{padding:'0px'}}>
                                        <div>
                                              {inplayerIds.length! > 0 && outPlayerIds?.length! > 0 && avgAgeDiff !== 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) && (
                                                  <>
                                                      <img height={14} width={10} src={avgAgeDiff > 0 ? UpArrow : DownArrow} alt="trend arrow" className={avgAgeDiff > 0 ? "arrow-up-bad" : "arrow-down-good"}/>
                                                      <LabelNumber className='event-player-card-details' style={{color : avgAgeDiff > 0 ? "#FF3864" : "#00D1A8"}}>
                                                          {Math.abs(avgAgeDiff)}
                                                      </LabelNumber>
                                                  </>
                                              )}
                                        </div>
                                        <div className="values-content">
                                            <LabelNumber className="event-player-card-details">
                                            {teamFinancialSimulationData?.beforValue?.avgAgeValue!}
                                            </LabelNumber>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                );
                            })()}
                        </div>
                </div>
                {section === "stylisticfit" && (
                    <div className='team-playing-style spider-graph-for-pdf'>
                        <div className='style-header-container'>
                            <div className='form-buttons-container'>
                                <LabelText className="player-detail-given-name">{activeArcheTypeName}</LabelText>
                                <img src={InfoIcon} height={24} width={24} onClick={()=>setTeamSidebarOpen(true)} style={{cursor:'pointer'}}/>
                            </div>
                            <div className='pitch-selection-container'>
                                <div className="archtype-info">
                                    <div className="archtype-tag" style={{background: inplayerIds?.length! > 0 && outPlayerIds?.length! > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) ? "#CFE6F4" : '#64ADDB'}}></div>
                                    <LabelText className="archtype-tag-text">Defensive</LabelText>
                                    </div>
                                <div className="archtype-info">
                                    <div className="archtype-tag" style={{background: inplayerIds?.length! > 0 && outPlayerIds?.length! > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) ? "#CFE6F4" : '#C9F0B5'}}></div>
                                    <LabelText className="archtype-tag-text">Build up play</LabelText>
                                </div>
                                <div className="archtype-info">
                                    <div className="archtype-tag" style={{background: inplayerIds?.length! > 0 && outPlayerIds?.length! > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) ? "#CFE6F4" : '#FFC2C2'}}></div>
                                    <LabelText className="archtype-tag-text">Final third</LabelText>
                                </div>
                            </div>
                        </div>
                        <div style={{display:'flex', gap:'20px',paddingTop:'20px'}}>
                            <div className="style-compariosn-containr">
                                <div className="comparison-content">
                                    <Switch id="starts-only" onChange={()=>setIscompareBlackLine(!isCompareBalckLine)} toggled={isCompareBalckLine} />
                                    <LabelText className="secondary-cta-text">Comparison (black line):</LabelText>
                                </div>
                                <div className="comparison-content">
                                    <input type="radio" id="archetype" className="custom-radio" name="archetype"
                                    checked={archeTypeBy === 'archetype'}
                                    onChange={()=>{setIsArchetypeBy('archetype')
                                      const activeArchetype = archetypes.find((a) => {
                                            const key =
                                              a?.archetypeId +
                                              a?.coachId +
                                              a?.competitionId +
                                              a?.ppg +
                                              a?.usagePercentage;
                                            return key === activeTeamGraph;
                                          });
                                          if (activeArchetype) {
                                            setTargetedFormation(activeArchetype?.archetypesBest?.formationName);
                                            // setTargetedArcheTypeFormation(activeArchetype?.archetypesBest?.formationName);
                                            setTargetedSeasonName(activeArchetype?.archetypesBest?.seasonName);
                                            setTargetTeamId(activeArchetype?.archetypesBest?.teamId);

                                      }}}
                                    ></input>
                                    <div className='values-box-content'>
                                        <LabelText className="secondary-cta-text">Playing style’s top performers </LabelText>
                                        <LabelNumber className='valuegraph-toggle-text'>{(getClubName() !== "" && getSeasonName() !== "" ? `${getClubName()} - ${getSeasonName()}` : '')}</LabelNumber>
                                        <LabelNumber className='valuegraph-toggle-text'>{targetedArcheTypeFormation!}</LabelNumber>
                                        <LabelNumber className='valuegraph-toggle-text'>{getStylisticFit() !== "" ? `stylistic fit = ${getStylisticFit()}` : ""}</LabelNumber>

                                    </div>
                                </div>
                                <div className="comparison-content">
                                    <input type="radio" id="coach" className="custom-radio" name="archetype"
                                    checked={archeTypeBy === 'coach'}
                                    onChange={()=>{setIsArchetypeBy('coach')
                                      const activeArchetype = archetypes.find((a) => {
                                            const key =
                                              a?.archetypeId +
                                              a?.coachId +
                                              a?.competitionId +
                                              a?.ppg +
                                              a?.usagePercentage;
                                            return key === activeTeamGraph;
                                          });
                                          if (activeArchetype) {
                                            setTargetedFormation(activeArchetype?.coachsBest?.formationName);
                                            setTargetedSeasonName(activeArchetype?.coachsBest?.seasonName);
                                            setTargetTeamId(activeArchetype?.coachsBest?.teamId);
                                          }}}></input>
                                    <div className='values-box-content'>
                                        <LabelText className="secondary-cta-text">Manager’s best season </LabelText>
                                        <LabelNumber className='valuegraph-toggle-text'>{(getClubNameForCoach() !== "" && getSeasonNameForCoach() !== "" ? `${getClubNameForCoach()} - ${getSeasonNameForCoach()}` : '')}</LabelNumber>
                                        <LabelNumber className='valuegraph-toggle-text'>{`${targetedFormation!}: ${getPlayingStyleForCoach()}`}</LabelNumber>
                                        <LabelNumber className='valuegraph-toggle-text'>{getStylisticFitForCoach() !== "" ? `stylistic fit = ${getStylisticFitForCoach()}` : ""}</LabelNumber>
                                        
                                    </div>
                                </div>
                                <div className="archtype-info">
                                  {compareClubLogoUrl && compareClubName && (<input type="radio" id="coach" className="custom-radio" name="archetype"
                                    checked={archeTypeBy === 'team'}
                                    onChange={()=>{setIsArchetypeBy('team');}}
                                    ></input>)}
                                    {compareClubLogoUrl && compareClubName && (
                                      <div style={{display:'flex',flexDirection:'column', gap:'4px'}}>
                                        <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                                          <img src={compareClubLogoUrl!} width={18} height={18} alt="club-logo" className="club-logo" />
                                          <LabelText className="archtype-tag-text">{compareClubName!}</LabelText>
                                        </div>
                                        <LabelNumber className='valuegraph-toggle-text'>{compareClubseasonLabel !== '' && `${compareClubseasonLabel} SEASON`}</LabelNumber>
                                        <LabelNumber className="valuegraph-toggle-text">{`Stylistic Fit = ${Number(((simulationData?.similarity?.before ?? 0) * 100).toFixed(2))}`}</LabelNumber>
                                      </div>
                                    )}
                                </div>
                                <div className="comparison-content">
                                    <SecondaryButton label="Comparison team" onClick={()=>setSimulationClubSearch(true)} iconType='add'/>
                                </div>
                            </div>
                            {/* {(inplayerIds.length > 0 && outPlayerIds.length > 0 ) ?  ( */}
                              <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                                {simulationData && (
                                  <>
                                    <SpiderSwapGraph
                                        data={processTeamSwapArchetypeData(simulationData!)}
                                        comparisonData={processTeamArchetypeData(comparisonTeamData[0]!)}
                                        isForComparison={clubCompareId! > 0}
                                        height={600}
                                        width={682}
                                        inPlayerIds={inplayerIds}
                                        outPlayerIds={outPlayerIds}
                                        isComparisonBlackLine={isCompareBalckLine}
                                        positionResults={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults}
                                        teamId={teamId}
                                    />
                                    {/* )} */}
                                  <div style={{position:'relative',bottom:'50%'}}>{swapDataLoading && (<LoadingSpinner/>)}</div>
                                  </>
                                )}
                                </div>
                              {/* ) : ( */}
                            {/* archetypeData
                                ?.filter((archetype) => (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!))
                                ?.map((archetype) => (
                                    <PolarAreaChart
                                    key={(archetype?.formationName!)}
                                    data={processTeamArchetypeData(archetype)}
                                    averageData={processTeamArchetypeData(comparisonTeamData[0]!)}
                                    isForComparison={false}
                                    height={600}
                                    width={682}
                                    isComparisonBlackLine={isCompareBalckLine}
                                    /> */}
                                
                               {/* )} */}
                        </div>
                        
                    </div>
                )}
                {section === "attributes" && (
                  <SimulationAttributes
                    initialAttributesData={teamAttributesData}
                    simulationAttributesData={simulationAttributesData!}
                    inPlayerIds={inplayerIds}
                    outPlayerIds={outPlayerIds}
                    positionResults={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults}
                    teamId={teamId}
                  />
                )}
                {section === "financial" && teamId! > 0 && seasonId! > 0 &&(
                  <div className="team-playing-style" style={{height:'max-content'}}>
                      <SquareBarChart teamId={Number(teamId)} simulationSeasonId={seasonId!} isForSimulation={true}/>
                  </div>
                )}
                {section === "financial" && squadPlayerComparisonData! && (
                  <div className="team-playing-style">
                    <SimulationPlayersTable
                      sortKey={sortKey}
                      setSortKey={setSortKey}
                      tableData={squadPlayerComparisonData!}
                      isFormSortList={false}
                      benchmarkID={0}
                      isFromSimulation={true}
                    />
                  </div>
                )}
            </div>
            )}
        </div>

        <div className="performance-right-container">
            <PrimaryButton
              label="Preview PDF"
              className='preview-pdf-btn'
              onClick={() => navigate(`/preview`, { state: { teamId: teamId,
                selectedSimulationTab: selectedSimulationTab,
                gameModelData: gameModelData,
                possessionPlayers: possessionPlayers,
                positionResults: (currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults),
                teamChemistry: (currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? teamChemistry : swappedTeamChemistry),
                possessionPasses: possessionPasses,
                formationData: formationData,
                selectedFormation: selectedFormation,
                // Pass values boxes data
                teamAttributesData: teamAttributesData,
                simulationAttributesData: simulationAttributesData,
                teamFinancialSimulationData: teamFinancialSimulationData,
                overallSystemFitScore: overallSystemFitScore,
                overAllswappSystemFitScore: overAllswappSystemFitScore,
                inPlayerIds: inplayerIds,
                outPlayerIds: outPlayerIds,
                squadPlayerComparisonData: squadPlayerComparisonData,
                seasonId: seasonId,
                simulationData: simulationData,
                comparisonTeamData: comparisonTeamData,
                clubCompareId: clubCompareId,
                // Additional props needed for SystemFitValuesAndContent (data only, no functions)
                activeArcheTypeName: activeArcheTypeName,
                archetypes: archetypes,
                isCompareBalckLine: isCompareBalckLine,
                swapDataLoading: swapDataLoading,
                compareClubLogoUrl: compareClubLogoUrl,
                compareClubName: compareClubName,
                compareClubseasonLabel: compareClubseasonLabel,
                // Pass computed values instead of functions
                stylisticFitValue: getStylisticFit(),
                stylisticFitForCoachValue: getStylisticFitForCoach(),
                compareStylisticFitValue: getCompareStylisticFit(),
                afterScoreValue: getAfterScore(),
                improvementValue: getImprovement(),
                clubNameValue: getClubName(),
                seasonNameValue: getSeasonName(),
                clubNameForCoachValue: getClubNameForCoach(),
                seasonNameForCoachValue: getSeasonNameForCoach(),
                playingStyleForCoachValue: getPlayingStyleForCoach(),
                targetedFormationValue: targetedFormation,
                targetedSeasonNameValue: targetedSeasonName,
                targetTeamIdValue: targetTeamId,
                targetedArcheTypeFormation: targetedArcheTypeFormation,
                targetedFormation: targetedFormation,
                activeTeamGraph: activeTeamGraph,
                archeTypeBy: archeTypeBy,
                matchBasicDetails: matchBasicDetails,
                selectedGameModelAttributes: selectedGameModelAttributes,
                seasonLabel: seasonLabel,
                coachName: coachName,
                activeformation: activeformation,
                swapHistory: swapHistory,
                userData: userData
              }})}
            />
            <div className="sub-form">
                <LabelText className="secondary-cta-text">Sub from</LabelText>
                 <div className="form-checkbox-list">
                    <div className='checkbox-main-container' style={{ background: getStyles("squad").background, border: getStyles("squad").border }}>
                        <div className='checkbox-label-container'>
                            <LabelText className="secondary-cta-text" style={{ color: getStyles("squad").color }}>Squad</LabelText>
                            <LabelNumber className='toggle-style-text' style={{ color: getStyles("squad").smallColor }}>{teamName}</LabelNumber>
                        </div>
                        <input type="radio" id="squad" className="custom-radio" name="subFrom" value="squad" 
                        checked={playerListFrom === 'squad'} onChange={() => setPlayerListFrom('squad')}></input>
                    </div>
                    <div className='checkbox-main-container' style={{ background: getStyles("shortlist").background, border: getStyles("shortlist").border }}>
                        <div className='checkbox-label-container'>
                            <LabelText className="secondary-cta-text" style={{ color: getStyles("shortlist").color }}>Your shortlist</LabelText>
                            {playerComparisonTableData?.length! > 0 &&(<LabelNumber className='toggle-style-text' style={{ color: getStyles("shortlist").smallColor }}>{playerComparisonTableData?.length!} PLAYERS</LabelNumber>)}
                        </div>
                        <input type="radio" id="shortlist" className="custom-radio" name="subFrom" value="shortlist"
                         checked={playerListFrom === 'shortlist'} onChange={() => setPlayerListFrom('shortlist')}></input>
                    </div>
                    {/* <div className='checkbox-main-container' style={{ background: getStyles("Recommended").background, border: getStyles("Recommended").border }}>
                        <div className='checkbox-label-container'>
                            <LabelText className="secondary-cta-text" style={{ color: getStyles("Recommended").color }}>Recommended</LabelText>
                            <LabelNumber className='toggle-style-text' style={{ color: getStyles("Recommended").smallColor }}>Possession builders</LabelNumber>
                        </div>
                        <input type="radio" id="Recommended" className="custom-radio" name="subFrom" value="Recommended"
                        checked={playerListFrom === 'Recommended'} onChange={() => setPlayerListFrom('Recommended')}>
                        </input>
                    </div> */}
                </div>
                <div className="form-buttons-container">
                {/* <SecondaryButton label="Add team" className='custom-performance-btns'/> */}
                <SecondaryButton label="Search player" onClick={()=>setSimulationPlayerSearch(true)} className='custom-performance-btns'/>
            </div>
            </div>
            <div className="dragable-playercard-container">
                <LabelText className="secondary-cta-text">Drag to replace</LabelText>
                {playerListFrom === 'squad' && (
                    <div className="playerlistfrom-container">
                        {squadPlayersData.map((player) => (
                            <>
                            <div className="playerlistfrom-box"  onClick={() => {
                                    setPlayerCardOpen(!playerCardOpen);
                                    setSelectedPlayer(player?.playerId);
                                }}>
                                <div className="playerlistfrom-content">
                                    <PlayerAvatar className={`player-table-image`}
                                        style={{backgroundImage: `url(${player?.playerImageURL || ""})`}}
                                        src={player?.playerImageURL ? player?.playerImageURL : undefined}
                                        backgroundImage={player?.playerImageURL}
                                        // onClick={()=>{handleSwapPlayer(player.playerId)}}
                                        onDragStart={(e) => {
                                        e.dataTransfer.setData("playerId", player?.playerId.toString()); // 🔑 Pass playerId
                                        }}
                                    ></PlayerAvatar>
                                    {/* <img src={player?.playerImageURL} height={48} width={48}
                                    draggable
                                        onDragStart={(e) => {
                                        e.dataTransfer.setData("playerId", player?.playerId.toString()); // 🔑 Pass playerId
                                        }}/> */}
                                    <div className="playerlistfrom-info">
                                        <LabelNumber className="playerlist-name" style={{textAlign:'left'}}>{player?.playerTmName}</LabelNumber>
                                        <div className='form-buttons-container'>
                                            <LabelNumber className='valuegraph-toggle-text'>{player?.primaryPlayingPosition}</LabelNumber>
                                            <LabelNumber className='stat-row-value'>{' • '}</LabelNumber>
                                            <LabelNumber className='valuegraph-toggle-text'>{player?.archetypes?.[0]?.archetypeName}</LabelNumber> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                             {selectedPlayer === player?.playerId && playerCardOpen && (
                            <div className="player-card" ref={playerCardRef}>
                                    <PlayerLandingCard
                                    playerId={player?.playerId!}
                                    givenName={player?.givenName!}
                                    familyname={player?.familyname!}
                                    playerImageURL={player?.playerImageURL!}
                                    isInjured={player?.isInjured!}
                                    onLoan={player?.onLoan!}
                                    primaryPlayingPosition={player?.primaryPlayingPosition!}
                                    age={player?.age!}
                                    heightInCM={player?.heightInCM!}
                                    playerAttributesByPosition={player?.playerAttributesByPosition!}
                                    contributionValue={player?.contributionValue!}
                                    performanceValue={player?.performanceValue!}
                                    setPlayerCardDeatils={setPlayerCardDeatils!}
                                    isRemoveAvailable={false}
                                    setPlayerCardID={setPlayerCardID!}
                                    isPlayerInShortlist={player?.isInShortlist!}
                                    isEasternPlayer={player?.isEasternPlayer!}
                                    playerLabel={player?.playerLabel!}
                                    archetypeName={player?.archetypeName!}
                                    archetypeId={player?.archetypeId!}
                                    trueValueText={playerCardDetails?.trueValueText}
                                    />
                            </div>
                        )}
                        </>
                        ))}
                    </div>
                )}

                {playerListFrom === 'shortlist' && (
                    <div className="playerlistfrom-container">
                        {playerComparisonTableData?.map((player) => (
                            <>
                            <div className="playerlistfrom-box"  onClick={() => {
                                    setPlayerCardOpen(!playerCardOpen);
                                    setSelectedPlayer(player?.playerId);
                                }}>
                                <div className="playerlistfrom-content">
                                    <PlayerAvatar className={`player-table-image`}
                                        style={{backgroundImage: `url(${player?.playerImageURL || ""})`}}
                                        src={player?.playerImageURL ? player?.playerImageURL : undefined}
                                        backgroundImage={player?.playerImageURL}
                                        // onClick={()=>{handleSwapPlayer(player.playerId)}}
                                        onDragStart={(e) => {
                                        e.dataTransfer.setData("playerId", player?.playerId.toString()); // 🔑 Pass playerId
                                        }}
                                    ></PlayerAvatar>
                                    {/* <img src={player?.playerImageURL} height={48} width={48}
                                    draggable
                                        onDragStart={(e) => {
                                        e.dataTransfer.setData("playerId", player?.playerId.toString()); // 🔑 Pass playerId
                                        }}/> */}
                                    <div className="playerlistfrom-info">
                                        <LabelNumber className="playerlist-name" style={{textAlign:'left'}}>{player?.playerLabel}</LabelNumber>
                                        <div className='form-buttons-container'>
                                            <LabelNumber className='valuegraph-toggle-text'>{player?.topPosition}</LabelNumber>
                                            <LabelNumber className='stat-row-value'>{' • '}</LabelNumber>
                                            <LabelNumber className='valuegraph-toggle-text'>{player?.archetype?.archetypeName}</LabelNumber> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                             {/* {selectedPlayer === player?.playerId && playerCardOpen && (
                            <div className="player-card" ref={playerCardRef}>
                                    <PlayerLandingCard
                                    playerId={player.playerId}
                                    givenName={player.givenName}
                                    familyname={player.familyname}
                                    playerImageURL={player.playerImageURL}
                                    isInjured={player.isInjured}
                                    onLoan={player.onLoan}
                                    primaryPlayingPosition={player.topPosition}
                                    age={player.age}
                                    heightInCM={player.heightInCM}
                                    playerAttributesByPosition={player.playerAttributesByPosition}
                                    contributionValue={player.contributionValue}
                                    performanceValue={player.performanceValue}
                                    setPlayerCardDeatils={setPlayerCardDeatils}
                                    setPlayerCardID={setPlayerCardID}
                                    isPlayerInShortlist={player.isInShortlist}
                                    isEasternPlayer={player.isEasternPlayer}
                                    playerLabel={player.playerLabel}
                                    archetypeName={player?.archetype?.archetypeName}
                                    archetypeId={player?.archetype?.id!}
                                    />
                            </div>
                        )} */}
                        {selectedPlayer === player?.playerId && playerCardDetails && playerCardOpen && (
                            <div className="player-card" ref={playerCardRef}>
                                <PlayerLandingCard
                                    playerId={playerCardDetails?.playerId!}
                                    givenName={playerCardDetails?.givenName!}
                                    familyname={playerCardDetails?.familyname!}
                                    playerImageURL={playerCardDetails?.playerImageURL!}
                                    isInjured={playerCardDetails?.isInjured!}
                                    onLoan={playerCardDetails?.onLoan!}
                                    primaryPlayingPosition={playerCardDetails?.primaryPlayingPosition!}
                                    age={playerCardDetails?.age!}
                                    heightInCM={playerCardDetails?.heightInCM!}
                                    playerAttributesByPosition={playerCardDetails?.playerAttributesByPosition!}
                                    contributionValue={playerCardDetails?.contributionValue!}
                                    performanceValue={playerCardDetails?.performanceValue!}
                                    setPlayerCardDeatils={setPlayerCardDeatils!}
                                    isRemoveAvailable={false}
                                    setPlayerCardID={setPlayerCardID!}
                                    isPlayerInShortlist={playerCardDetails?.isInShortlist!}
                                    isEasternPlayer={playerCardDetails?.isEasternPlayer!}
                                    playerLabel={playerCardDetails?.playerLabel!}
                                    archetypeName={playerCardDetails?.archetypeName!}
                                    archetypeId={playerCardDetails?.archetypeId!}
                                    trueValueText={playerCardDetails?.trueValueText!}
                                />
                            </div>
                          )}
                        </>
                        ))}
                    </div>
                )}
                {/* <BackToTeamChemistryBtn onClick={handleExportToPDF} style={{width: '200px', fontSize: '20px', marginTop: '17px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginInline: 'auto'}} >
                  <span>📥</span>
                  Export to PDF
                </BackToTeamChemistryBtn> */}
            </div>
        </div>
    </div>
    {pitchSettingDrawerOpen && (
        <Drawer
               PaperProps={{
                    style: {
                    left: "70px",
                    backgroundColor: "transparent",
                    backdropFilter: "blur(16px)",
                    width: "100%",
                    overflowY: "hidden",
                   
                    },
                }}
              anchor="left"
              variant="persistent"
              open={pitchSettingDrawerOpen}
              onClose={() => {
                setPitchSettingDrawerOpen(false);
              }}
            >
            <DrawerContainer className="main-drawer-container" style={{width:'450px', boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)',}}>
                <div className="drawer-header">
                    <LabelText className="drawer-title">Pitch Settings</LabelText>
                    <div className="header-buttons">
                    <ForawrdBackwardButton onClick={() => setPitchSettingDrawerOpen(false)}>
                        <CloseIcon className="cta-btn-icons" />
                    </ForawrdBackwardButton>
                    </div>
                </div>
                <div className="pitch-settings-container">
                    {/* <div className="timeframe">
                        <LabelText className="secondary-cta-text">Timeframe</LabelText>
                        <PrimaryButton label="Last Match" onClick={() => setTimeframeDrawerOpen(true)}/>
                    </div> */}
                    <div className="timeframe">
                        <LabelText className="header-text">Select a season</LabelText>
                        <StandardDropdown
                            placeholder="Select a season"
                            options={seasonData}
                            isDisplaySearchInput={false}
                            onChange={handleSeasonChange}
                            defaultSelected={seasonLabel}
                        />
                    </div>
                    {/* <div className="timeframe">
                        <LabelText className="secondary-cta-text">Manager</LabelText>
                        {teamCoaches.map((coach , index)=>{
                            const backgroundColor = coachId === coach.coachId ? '#00A1E4' : 'transparent';
                            const border = coachId === coach.coachId ? '1px solid var(--Shades-UI-Blue-blue-600, #0093CF)' : '1px solid var(--Shades-UI-Blue-blue-600, #DADADA)';
                            const color = coachId === coach.coachId ? 'white' : 'black'
                            const smallColor = coachId === coach.coachId ? 'white' : '#7C7D79'
                            return(
                            <div className="checkbox-main-container" key={coach.coachId} style={{background: backgroundColor,border:border}}>
                                <div className='checkbox-label-container'>
                                    <LabelText className="secondary-cta-text" style={{color:color}}>{coach.coachName}</LabelText>
                                    <LabelNumber className='toggle-style-text' style={{color:smallColor}}>{coach.fromSeason} – {coach.toSeason}</LabelNumber>
                                </div>
                                <input 
                                type="radio" 
                                id={`coach-${index}`}
                                className="custom-radio" 
                                name="manager-selection" 
                                value={coach.coachId} 
                                onChange={()=>{ setCoachId(coach.coachId)
                                    setCoachName(coach.coachName)
                                }}
                                checked={coachId === coach.coachId}/>
                            </div>
                        )})}
                    </div> */}
                    <div className="timeframe">
                        <LabelText className="secondary-cta-text">Playing Style</LabelText>
                       {archetypes.map((archetype, index) => {
                            const archetypeKey =archetype?.archetypeId +archetype?.coachId +archetype?.competitionId +archetype?.ppg +archetype?.usagePercentage;
                            const backgroundColor = activeTeamGraph === archetypeKey ? '#00A1E4' : 'transparent';
                            const border = activeTeamGraph === archetypeKey ? '1px solid var(--Shades-UI-Blue-blue-600, #0093CF)' : '1px solid var(--Shades-UI-Blue-blue-600, #DADADA)';
                            const color = activeTeamGraph === archetypeKey ? 'white' : 'black'
                            const smallColor = activeTeamGraph === archetypeKey ? 'white' : '#7C7D79'
                            return (
                                <div key={archetypeKey} className="checkbox-main-container" style={{background: backgroundColor,border:border}}>
                                    <div className="checkbox-label-container">
                                        <LabelText className="secondary-cta-text" style={{color:color}}>{archetype?.formationName}</LabelText>
                                        <LabelText className="secondary-cta-text" style={{color:color}}>{archetype?.archetypeName}</LabelText>
                                        <LabelNumber className="toggle-style-text" style={{color:smallColor}}>Usage percentage: {archetype?.usagePercentage}%</LabelNumber>
                                        <LabelNumber className="toggle-style-text" style={{color:smallColor}}>PTS per game: {archetype?.ppg}</LabelNumber>
                                        <LabelNumber className="toggle-style-text" style={{color:smallColor}}>Manager: {archetype?.coachName}</LabelNumber>
                                    </div>
                                    <div className="form-checkbox-list" style={{ justifyContent: "space-between" }}>
                                        <input
                                        type="radio"
                                        id={`archetype-${index}`}
                                        className="custom-radio"
                                        name="archetype-selection"
                                        value={archetypeKey}
                                        checked={activeTeamGraph === archetypeKey}
                                        onChange={() => {
                                            setActiveTeamGraph(archetypeKey);
                                            setActiveArcheTypeId(archetype?.archetypeId!)
                                            setActiveFormation(archetype?.formationName!)
                                            setFormationId(archetype?.formationId!)
                                            setCoachName(archetype?.coachName)
                                            // setTargetedFormation(archetype?.coachsBest?.formationName)
                                            setTargetedArcheTypeFormation(archetype?.archetypesBest?.formationName)
                                             if(archeTypeBy === 'coach') {setTargetedFormation(archetype?.coachsBest?.formationName)} else{setTargetedFormation(archetype?.archetypesBest?.formationName)}
                                             if(archeTypeBy === 'coach') {setTargetedSeasonName(archetype?.coachsBest?.seasonName)} else{setTargetedSeasonName(archetype?.archetypesBest?.seasonName)}
                                             if(archeTypeBy === 'coach') {setTargetTeamId(archetype?.coachsBest?.teamId)} else{setTargetTeamId(archetype?.archetypesBest?.teamId)}

                                            setActiveArcheTypeName(archetype?.archetypeName!)
                                        }}
                                        />
                                        <label htmlFor={`archetype-${index}`}><img src={InfoIcon} alt="info" style={{color:color}} /></label>
                                    </div>
                                </div>
                            );
                            })}
                    </div>
                    {loading && (<ModuleSpinner/>)}
                </div>
                <SearchResults className="search-profile-result">
                    <PrimaryButton  iconType="confirm" label="Confirm" onClick={()=>{handleConfirm()}}/>
                </SearchResults>
          </DrawerContainer>
        </Drawer>
        
    )}
    {/* <TimeframeDrawer
        isOpen={timeframeDrawerOpen}
        onClose={() => setTimeframeDrawerOpen(false)}
        teamId={teamId}
        seasonData={seasonData}
        teamMatchByMonthsData={teamMatchesByMonth}
        onConfirm={handleConfirm}
        zoomLevelId={zoomLevelId}
        selectedSeasonId={selectedSeasonId}
    /> */}
    {loading && (<LoadingSpinner/>)}
    {simulationPlayerSearch && <SimulationPlayerSearch open={simulationPlayerSearch} playerComparisonTableData={playerComparisonTableData} setIsOpen={setSimulationPlayerSearch} headerLabel="Search Player" onAddToShortlist={handleAddToShortlist}/>}
    {simulationClubSearch && <ClubInitialSearch open={simulationClubSearch} setIsOpen={setSimulationClubSearch} archtypeId={activeArcheTypeId!}
    isFromSimulation={true} teamId={teamId} handleSeasonChange={handleCompareClubSeasonChange} seasonData={compareClubSeasonData}  seasonLabel={compareClubseasonLabel} handleConfirm={handleCompareTeam}/>}

    <TeamArchetypeInfoDrawer
          teamsidebarOpen={teamsidebarOpen}
          setTeamSidebarOpen={setTeamSidebarOpen}
          archetypeName={activeArcheTypeName}
          activeArchetypeID={activeArcheTypeId}
    />

    {/* Timeline drawer for possessions */}
    <Timeline
        isOpen={timeLineDrawerOpen}
        onClose={() => setTimeLineDrawerOpen(false)}
        teamId={teamId}
        seasonData={seasonData}
        teamMatchByMonthsData={teamMatchesByMonth}
        onConfirm={handleTimelineConfirm}
        zoomLevelId={zoomLevelId}
        selectedSeasonId={selectedSeasonId}
        onSeasonChange={handleTimelineSeasonChange}
    />

    </>
  )
}

export default PerformanceVersion2